
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref85b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref85b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("Loi7S", function(module, exports) {

$parcel$export(module.exports, "createNotes", function () { return $08e73ba89a2710b5$export$a6281618eba5c8a8; });
$parcel$export(module.exports, "editNotes", function () { return $08e73ba89a2710b5$export$4f3d4ef8cc12870; });
$parcel$export(module.exports, "createTodos", function () { return $08e73ba89a2710b5$export$d73c8b8ba60e493f; });
$parcel$export(module.exports, "editTodos", function () { return $08e73ba89a2710b5$export$298a394e1066cd97; });
$parcel$export(module.exports, "createScrumBoard", function () { return $08e73ba89a2710b5$export$fdfb1371bb41f6ab; });
$parcel$export(module.exports, "createNewList", function () { return $08e73ba89a2710b5$export$6819fc501dde6d24; });
$parcel$export(module.exports, "createEvent", function () { return $08e73ba89a2710b5$export$c30017717ce2168e; });
var $08e73ba89a2710b5$export$846d0d105943fb86 = {
    notes: []
};
var $08e73ba89a2710b5$export$bd1c7d1f0790489f = {
    scrumboard: [],
    todo: [],
    settings: {}
};
var $08e73ba89a2710b5$var$generateShortId = function generateShortId(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var result = "";
    for(var i = 0; i < length; i++){
        var randomIndex = Math.floor(Math.random() * chars.length);
        result += chars.charAt(randomIndex);
    }
    return result;
};
var $08e73ba89a2710b5$export$a6281618eba5c8a8 = function createNotes() {
    var today = new Date().toISOString();
    var noteTitle = document.getElementById("n-title").value;
    var noteDescription = document.getElementById("n-description").value;
    var noteTag = document.getElementById("n-tags").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: shortId,
        title: noteTitle,
        description: noteDescription,
        tag: noteTag,
        date: today,
        favorited: 0
    };
    $08e73ba89a2710b5$export$846d0d105943fb86.notes.push(data);
    return data;
};
var $08e73ba89a2710b5$export$4f3d4ef8cc12870 = function editNotes(noteId, favorited) {
    var today = new Date().toISOString();
    var noteTitle = document.getElementById("n-title").value;
    var noteDescription = document.getElementById("n-description").value;
    var noteTag = document.getElementById("n-tags").value;
    var data = {
        id: noteId,
        title: noteTitle,
        description: noteDescription,
        tag: noteTag,
        date: today,
        favorited: favorited
    };
    return data;
};
var $08e73ba89a2710b5$export$d73c8b8ba60e493f = function createTodos(quill) {
    var today = new Date().toISOString();
    var todoTitle = document.getElementById("task-text").value;
    // const todoDescription = quill.getText().trim();
    var todoDescription = quill.root.innerHTML;
    var todoPriority = document.getElementById("priority").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: shortId,
        title: todoTitle,
        description: todoDescription,
        priority: todoPriority,
        important: 0,
        completed: 0,
        trash: 0,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$298a394e1066cd97 = function editTodos(quill, options) {
    var today = new Date().toISOString();
    var todoTitle = document.getElementById("task-text").value;
    // const todoDescription = quill.getText().trim();
    var todoDescription = quill.root.innerHTML;
    var todoPriority = document.getElementById("priority").value;
    var data = {
        id: options.todoId,
        title: todoTitle,
        description: todoDescription,
        priority: todoPriority,
        important: options.important,
        completed: options.completed,
        trash: options.trash,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$fdfb1371bb41f6ab = function createScrumBoard(options) {
    var isEdit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth());
    var yyyy = today.getFullYear();
    // prettier-ignore
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    today = dd + " " + monthNames[mm] + ", " + yyyy;
    var taskTitle = document.getElementById("s-task").value;
    var taskText = document.getElementById("s-text").value;
    var progress = document.getElementById("s-progress").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: isEdit ? options.id : shortId,
        title: taskTitle,
        description: taskText,
        tasksection: options.tasksection,
        order: options.order,
        progress: progress,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$6819fc501dde6d24 = function createNewList() {
    var isEdit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, order = arguments.length > 2 ? arguments[2] : void 0;
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = "".concat(mm, ".").concat(dd, ".").concat(yyyy);
    var listId = $08e73ba89a2710b5$var$generateShortId(5);
    var listTitle = document.getElementById("s-list-name").value;
    var listTitleLower = listTitle.toLowerCase();
    var listTitleRemoveWhiteSpaces = listTitleLower.split(" ").join("_");
    var listSectionDataAttr = "s-".concat(listTitleRemoveWhiteSpaces, "-").concat(listId);
    var data = {
        id: isEdit ? options.section : listSectionDataAttr,
        title: listTitle,
        order: isEdit ? options.order : order,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$c30017717ce2168e = function createEvent() {
    var isEdit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, OldEventId = arguments.length > 1 ? arguments[1] : void 0;
    var getModalCheckedRadioBtnEl = document.querySelector('input[name="event-level"]:checked');
    var getTitleValue = document.querySelector("#event-title").value;
    var setModalStartDateValue = document.querySelector("#event-start-date").value;
    var setModalEndDateValue = document.querySelector("#event-end-date").value;
    var setModalUrlValue = document.querySelector("#event-url").value;
    var getModalCheckedRadioBtnValue = getModalCheckedRadioBtnEl !== null ? getModalCheckedRadioBtnEl.value : "";
    var eventID = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: isEdit ? OldEventId : eventID,
        title: getTitleValue,
        start: setModalStartDateValue,
        end: setModalEndDateValue,
        url: setModalUrlValue,
        allDay: false,
        extendedProps: {
            calendar: getModalCheckedRadioBtnValue
        }
    };
    return data;
};

});

parcelRegister("ev0Km", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e48a38ea1e4026$export$2e2bcd8739ae039; });

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $dACZV = parcelRequire("dACZV");

var $jhb1H = parcelRequire("jhb1H");

var $2B8he = parcelRequire("2B8he");
var $a8e48a38ea1e4026$var$previewView = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $dACZV._)(previewView, appView);
    var _super = (0, $jhb1H._)(previewView);
    function previewView() {
        (0, $5kWiG._)(this, previewView);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(previewView, [
        {
            key: "notesMarkup",
            value: function notesMarkup(data, options) {
                return '\n          <div class="note-item all-notes '.concat(data.tag, " ").concat(options.favorite, '" data-id="').concat(data.id, '" data-favorited="').concat(data.favorited, '">\n            <div class="note-inner-content">\n              <div class="note-content">\n                <p class="note-title" data-noteTitle="').concat(data.title, '">\n                  ').concat(options.limitTitle, '\n                </p>\n                <p class="meta-time">\n                 ').concat(options.edited, " ").concat(options.newDate, '\n                </p>\n                <div class="note-description-content">\n                  <p class="note-description" data-noteDescription="').concat(data.description, '">\n                    ').concat(options.limitDescription, '\n                  </p>\n                </div>\n              </div>\n              <div class="note-action">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star fav-note">\n                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 delete-note">\n                  <polyline points="3 6 5 6 21 6"></polyline>\n                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                  <line x1="10" y1="11" x2="10" y2="17"></line>\n                  <line x1="14" y1="11" x2="14" y2="17"></line>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 edit-note"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>\n              </div>\n              <div class="note-footer">\n                <div class="tags-selector btn-group">\n                  <a class="nav-link dropdown-toggle d-icon label-group" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="true">\n                    <span>\n                      <div class="tags">\n                        <div class="g-dot-personal"></div>\n                        <div class="g-dot-work"></div>\n                        <div class="g-dot-social"></div>\n                        <div class="g-dot-important"></div>\n                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                          <circle cx="12" cy="12" r="1"></circle>\n                          <circle cx="12" cy="5" r="1"></circle>\n                          <circle cx="12" cy="19" r="1"></circle>\n                        </svg>\n                      </div>\n                    </span>\n                  </a>\n                  <div class="dropdown-menu dropdown-menu-right d-icon-menu">\n                    <a class="note-personal label-group-item label-personal dropdown-item position-relative g-dot-personal" href="javascript:void(0);"> Personal</a>\n                    <a class="note-work label-group-item label-work dropdown-item position-relative g-dot-work" href="javascript:void(0);"> Work</a>\n                    <a class="note-social label-group-item label-social dropdown-item position-relative g-dot-social" href="javascript:void(0);"> Social</a>\n                    <a class="note-important label-group-item label-important dropdown-item position-relative g-dot-important" href="javascript:void(0);"> Important</a>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        ');
            }
        },
        {
            key: "todoMarkup",
            value: function todoMarkup(data, options) {
                return '\n      <div class="todo-item '.concat(data.trash ? "" : "all-list", " ").concat(options.important, " ").concat(options.completed, " ").concat(options.trash, '" data-id="').concat(data.id, '" data-completed="').concat(data.completed, '" data-trash="').concat(data.trash, '"\n      data-important="').concat(data.important, '" data-priority="').concat(data.priority, '">\n        <div class="todo-item-inner">\n          <div class="n-chk text-center">\n            <div class="form-check form-check-primary form-check-inline mt-1 me-0" data-bs-toggle="collapse" data-bs-target="">\n              <input class="form-check-input inbox-chkbox" type="checkbox" ').concat(data.completed ? "checked" : "", '>\n            </div>\n          </div>\n\n          <div class="todo-content">\n            <h5 class="todo-heading" data-todoheading="').concat(data.title, '">\n             ').concat(options.limitTitle, '\n            </h5>\n            <p class="todo-text" data-todohtml="').concat(data.description, '" data-todotext="').concat(data.description, '">\n              ').concat(data.description, '\n            </p>\n          </div>\n\n          <div class="meta-frame">\n            <p class="meta-time todo-time">').concat(options.isCompleted, " ").concat(options.edited, " ").concat(options.newDate, '</p>\n          </div>\n\n          <div class="priority-dropdown custom-dropdown-icon">\n            <div class="dropdown p-dropdown">\n              <a class="dropdown-toggle ').concat(data.priority, '" href="#" role="button" id="dropdownMenuLink-1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                  <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                  <line x1="12" y1="8" x2="12" y2="12"></line>\n                  <line x1="12" y1="16" x2="12" y2="16"></line>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-1">\n                <a class="danger dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  High</a>\n                <a class="warning dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Middle</a>\n                <a class="primary dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Low</a>\n              </div>\n            </div>\n          </div>\n\n          <div class="action-dropdown custom-dropdown-icon">\n            <div class="dropdown">\n              <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                  <circle cx="12" cy="12" r="1"></circle>\n                  <circle cx="12" cy="5" r="1"></circle>\n                  <circle cx="12" cy="19" r="1"></circle>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-2">\n                <a class="edit dropdown-item" href="javascript:void(0);">Edit</a>\n                <a class="important dropdown-item" href="javascript:void(0);">').concat(data.important === 1 ? "Mark as Normal" : "Mark as Important", '</a>\n                <a class="dropdown-item delete" href="javascript:void(0);">Delete</a>\n                <a class="dropdown-item permanent-delete" href="javascript:void(0);">Permanent Delete</a>\n                <a class="dropdown-item revive" href="javascript:void(0);">Revive Task</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ');
            }
        },
        {
            key: "scrumBoardMarkup",
            value: function scrumBoardMarkup(data) {
                return '\n        <div data-draggable="true" data-list-id="'.concat(data.tasksection, '" data-card-id="').concat(data.id, '" data-order="').concat(data.order, '" class="card task-text-progress" style="">\n          <div class="card-body">\n            <div class="task-header">\n              <div>\n                <h4 class="" data-taskTitle="').concat(data.title, '">').concat(data.title, '</h4>\n              </div>\n              <div>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 s-task-edit">\n                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>\n                </svg>\n              </div>\n            </div>\n            <div class="task-body">\n              <div class="task-content">\n                <p class="" data-taskText="').concat(data.description, '">').concat(data.description, '</p>\n                <div class="').concat(data.progress ? "" : "progress-none-bar d-none", '">\n                    <div class="progress br-30">\n                      <div class="progress-bar bg-success" role="progressbar" data-progressstate="').concat(data.progress, '" style="width: ').concat(data.progress, '%" aria-valuenow="').concat(data.progress, '" aria-valuemin="0" aria-valuemax="100">\n                      </div>\n                    </div>\n                    <p class="progress-count">').concat(data.progress, '%</p>\n                </div>\n              </div>\n              <div class="task-bottom">\n                <div class="tb-section-1">\n                  <span data-taskDate="').concat(data.date, '">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar">\n                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>\n                      <line x1="16" y1="2" x2="16" y2="6"></line>\n                      <line x1="8" y1="2" x2="8" y2="6"></line>\n                      <line x1="3" y1="10" x2="21" y2="10"></line>\n                    </svg>\n                    ').concat(data.date, '\n                  </span>\n                </div>\n                <div class="tb-section-2">\n                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 s-task-delete">\n                    <polyline points="3 6 5 6 21 6"></polyline>\n                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                    <line x1="10" y1="11" x2="10" y2="17"></line>\n                    <line x1="14" y1="11" x2="14" y2="17"></line>\n                  </svg>\n                </div>\n              </div>\n            </div>\n          </div>');
            }
        },
        {
            key: "scrumListMarkup",
            value: function scrumListMarkup(data) {
                return '\n    <div data-section="'.concat(data.id, '" data-order="').concat(data.order, '" class="task-list-container mb-4 " data-connect="sorting">\n      <div class="connect-sorting">\n        <div class="task-container-header">\n          <h6 class="s-heading" data-listTitle="').concat(data.title, '">\n            ').concat(data.title, '\n          </h6>\n          <div class="dropdown">\n            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-4" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">\n                <circle cx="12" cy="12" r="1"></circle>\n                <circle cx="19" cy="12" r="1"></circle>\n                <circle cx="5" cy="12" r="1"></circle>\n              </svg>\n            </a>\n            <div class="dropdown-menu dropdown-menu-right left" aria-labelledby="dropdownMenuLink-4">\n              <a class="dropdown-item list-edit" href="javascript:void(0);">Edit List</a>\n              <a class="dropdown-item list-delete" href="javascript:void(0);">Delete List</a>\n              <a class="dropdown-item list-clear-all" href="javascript:void(0);">Clear All Cards</a>\n            </div>\n          </div>\n        </div>\n        <div class="connect-sorting-content" data-sortable="true">\n        </div>\n        <div class="add-s-task">\n          <a class="addTask">\n            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">\n              <circle cx="12" cy="12" r="10"></circle>\n              <line x1="12" y1="8" x2="12" y2="16"></line>\n              <line x1="8" y1="12" x2="16" y2="12"></line>\n            </svg>\n            Add Task\n          </a>\n        </div>\n      </div>\n    </div>\n  ');
            }
        },
        {
            key: "timeLineMarkup",
            value: function timeLineMarkup(data, timeFormat) {
                return '\n          <div class="item-timeline">\n            <p class="t-time">'.concat(timeFormat.timeDigits, '</p>\n            <div class="t-dot t-dot-').concat(data.tag, '"></div>\n            <div class="t-text">\n              <p>').concat(data.title, '</p>\n              <p class="t-meta-time">').concat(timeFormat.timeAgo, "</p>\n              ").concat(data.startdate ? '<p class="t-meta-time event-time"> '.concat(data.startdate, "</p>") : "", "\n            </div>\n          </div>\n    ");
            }
        }
    ]);
    return previewView;
}((0, $2B8he.default));
var $a8e48a38ea1e4026$export$2e2bcd8739ae039 = new $a8e48a38ea1e4026$var$previewView();

});


var $1K4o4 = parcelRequire("1K4o4");

var $e2996 = parcelRequire("e2996");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $dACZV = parcelRequire("dACZV");

var $jhb1H = parcelRequire("jhb1H");

var $gAasq = parcelRequire("gAasq");

var $gAasq = parcelRequire("gAasq");
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $ccad6e4b6cd876c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ccad6e4b6cd876c0$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ccad6e4b6cd876c0$var$ownKeys(Object(source), true).forEach(function(key) {
            $ccad6e4b6cd876c0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ccad6e4b6cd876c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ccad6e4b6cd876c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ccad6e4b6cd876c0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ccad6e4b6cd876c0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ccad6e4b6cd876c0$var$_typeof(obj);
}
function $ccad6e4b6cd876c0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ccad6e4b6cd876c0$var$_extends() {
    $ccad6e4b6cd876c0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ccad6e4b6cd876c0$var$_extends.apply(this, arguments);
}
function $ccad6e4b6cd876c0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ccad6e4b6cd876c0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ccad6e4b6cd876c0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ccad6e4b6cd876c0$var$_toConsumableArray(arr) {
    return $ccad6e4b6cd876c0$var$_arrayWithoutHoles(arr) || $ccad6e4b6cd876c0$var$_iterableToArray(arr) || $ccad6e4b6cd876c0$var$_unsupportedIterableToArray(arr) || $ccad6e4b6cd876c0$var$_nonIterableSpread();
}
function $ccad6e4b6cd876c0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ccad6e4b6cd876c0$var$_arrayLikeToArray(arr);
}
function $ccad6e4b6cd876c0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ccad6e4b6cd876c0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ccad6e4b6cd876c0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ccad6e4b6cd876c0$var$_arrayLikeToArray(o, minLen);
}
function $ccad6e4b6cd876c0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ccad6e4b6cd876c0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $ccad6e4b6cd876c0$var$version = "1.15.0";
function $ccad6e4b6cd876c0$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $ccad6e4b6cd876c0$var$IE11OrLess = $ccad6e4b6cd876c0$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $ccad6e4b6cd876c0$var$Edge = $ccad6e4b6cd876c0$var$userAgent(/Edge/i);
var $ccad6e4b6cd876c0$var$FireFox = $ccad6e4b6cd876c0$var$userAgent(/firefox/i);
var $ccad6e4b6cd876c0$var$Safari = $ccad6e4b6cd876c0$var$userAgent(/safari/i) && !$ccad6e4b6cd876c0$var$userAgent(/chrome/i) && !$ccad6e4b6cd876c0$var$userAgent(/android/i);
var $ccad6e4b6cd876c0$var$IOS = $ccad6e4b6cd876c0$var$userAgent(/iP(ad|od|hone)/i);
var $ccad6e4b6cd876c0$var$ChromeForAndroid = $ccad6e4b6cd876c0$var$userAgent(/chrome/i) && $ccad6e4b6cd876c0$var$userAgent(/android/i);
var $ccad6e4b6cd876c0$var$captureMode = {
    capture: false,
    passive: false
};
function $ccad6e4b6cd876c0$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$ccad6e4b6cd876c0$var$IE11OrLess && $ccad6e4b6cd876c0$var$captureMode);
}
function $ccad6e4b6cd876c0$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$ccad6e4b6cd876c0$var$IE11OrLess && $ccad6e4b6cd876c0$var$captureMode);
}
function $ccad6e4b6cd876c0$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $ccad6e4b6cd876c0$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $ccad6e4b6cd876c0$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $ccad6e4b6cd876c0$var$matches(el, selector) : $ccad6e4b6cd876c0$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $ccad6e4b6cd876c0$var$getParentOrHost(el));
    }
    return null;
}
var $ccad6e4b6cd876c0$var$R_SPACE = /\s+/g;
function $ccad6e4b6cd876c0$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($ccad6e4b6cd876c0$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($ccad6e4b6cd876c0$var$R_SPACE, " ");
        }
    }
}
function $ccad6e4b6cd876c0$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $ccad6e4b6cd876c0$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $ccad6e4b6cd876c0$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $ccad6e4b6cd876c0$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $ccad6e4b6cd876c0$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $ccad6e4b6cd876c0$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $ccad6e4b6cd876c0$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$ccad6e4b6cd876c0$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($ccad6e4b6cd876c0$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $ccad6e4b6cd876c0$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($ccad6e4b6cd876c0$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($ccad6e4b6cd876c0$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $ccad6e4b6cd876c0$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $ccad6e4b6cd876c0$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $ccad6e4b6cd876c0$var$getParentAutoScrollElement(el, true), elSideVal = $ccad6e4b6cd876c0$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $ccad6e4b6cd876c0$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $ccad6e4b6cd876c0$var$getWindowScrollingElement()) break;
        parent = $ccad6e4b6cd876c0$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $ccad6e4b6cd876c0$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $ccad6e4b6cd876c0$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $ccad6e4b6cd876c0$export$31b3ca70d8f57423.dragged) && $ccad6e4b6cd876c0$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $ccad6e4b6cd876c0$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $ccad6e4b6cd876c0$export$31b3ca70d8f57423.ghost || $ccad6e4b6cd876c0$var$css(last, "display") === "none" || selector && !$ccad6e4b6cd876c0$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $ccad6e4b6cd876c0$var$index(el, selector) {
    var _$index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $ccad6e4b6cd876c0$export$31b3ca70d8f57423.clone && (!selector || $ccad6e4b6cd876c0$var$matches(el, selector))) _$index++;
    return _$index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $ccad6e4b6cd876c0$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $ccad6e4b6cd876c0$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $ccad6e4b6cd876c0$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $ccad6e4b6cd876c0$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $ccad6e4b6cd876c0$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $ccad6e4b6cd876c0$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $ccad6e4b6cd876c0$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $ccad6e4b6cd876c0$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $ccad6e4b6cd876c0$var$getWindowScrollingElement();
}
function $ccad6e4b6cd876c0$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $ccad6e4b6cd876c0$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $ccad6e4b6cd876c0$var$_throttleTimeout;
function $ccad6e4b6cd876c0$var$throttle(callback, ms) {
    return function() {
        if (!$ccad6e4b6cd876c0$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $ccad6e4b6cd876c0$var$_throttleTimeout = setTimeout(function() {
                $ccad6e4b6cd876c0$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $ccad6e4b6cd876c0$var$cancelThrottle() {
    clearTimeout($ccad6e4b6cd876c0$var$_throttleTimeout);
    $ccad6e4b6cd876c0$var$_throttleTimeout = void 0;
}
function $ccad6e4b6cd876c0$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $ccad6e4b6cd876c0$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $ccad6e4b6cd876c0$var$setRect(el, rect) {
    $ccad6e4b6cd876c0$var$css(el, "position", "absolute");
    $ccad6e4b6cd876c0$var$css(el, "top", rect.top);
    $ccad6e4b6cd876c0$var$css(el, "left", rect.left);
    $ccad6e4b6cd876c0$var$css(el, "width", rect.width);
    $ccad6e4b6cd876c0$var$css(el, "height", rect.height);
}
function $ccad6e4b6cd876c0$var$unsetRect(el) {
    $ccad6e4b6cd876c0$var$css(el, "position", "");
    $ccad6e4b6cd876c0$var$css(el, "top", "");
    $ccad6e4b6cd876c0$var$css(el, "left", "");
    $ccad6e4b6cd876c0$var$css(el, "width", "");
    $ccad6e4b6cd876c0$var$css(el, "height", "");
}
var $ccad6e4b6cd876c0$var$expando = "Sortable" + new Date().getTime();
function $ccad6e4b6cd876c0$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($ccad6e4b6cd876c0$var$css(child, "display") === "none" || child === $ccad6e4b6cd876c0$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $ccad6e4b6cd876c0$var$getRect(child)
                });
                var fromRect = $ccad6e4b6cd876c0$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $ccad6e4b6cd876c0$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($ccad6e4b6cd876c0$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $ccad6e4b6cd876c0$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $ccad6e4b6cd876c0$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($ccad6e4b6cd876c0$var$isRectEqual(prevFromRect, toRect) && !$ccad6e4b6cd876c0$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $ccad6e4b6cd876c0$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                } // if fromRect != toRect: animate
                if (!$ccad6e4b6cd876c0$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $ccad6e4b6cd876c0$var$css(target, "transition", "");
                $ccad6e4b6cd876c0$var$css(target, "transform", "");
                var elMatrix = $ccad6e4b6cd876c0$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $ccad6e4b6cd876c0$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $ccad6e4b6cd876c0$var$repaint(target); // repaint
                $ccad6e4b6cd876c0$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $ccad6e4b6cd876c0$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $ccad6e4b6cd876c0$var$css(target, "transition", "");
                    $ccad6e4b6cd876c0$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $ccad6e4b6cd876c0$var$repaint(target) {
    return target.offsetWidth;
}
function $ccad6e4b6cd876c0$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $ccad6e4b6cd876c0$var$plugins = [];
var $ccad6e4b6cd876c0$var$defaults = {
    initializeByDefault: true
};
var $ccad6e4b6cd876c0$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $ccad6e4b6cd876c0$var$defaults)if ($ccad6e4b6cd876c0$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $ccad6e4b6cd876c0$var$defaults[option];
        $ccad6e4b6cd876c0$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $ccad6e4b6cd876c0$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $ccad6e4b6cd876c0$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($ccad6e4b6cd876c0$var$_objectSpread2({
                sortable: sortable
            }, evt));
             // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($ccad6e4b6cd876c0$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $ccad6e4b6cd876c0$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized; // Add default options from plugin
            $ccad6e4b6cd876c0$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $ccad6e4b6cd876c0$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $ccad6e4b6cd876c0$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $ccad6e4b6cd876c0$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $ccad6e4b6cd876c0$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$ccad6e4b6cd876c0$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature
    if (window.CustomEvent && !$ccad6e4b6cd876c0$var$IE11OrLess && !$ccad6e4b6cd876c0$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $ccad6e4b6cd876c0$var$_objectSpread2($ccad6e4b6cd876c0$var$_objectSpread2({}, extraEventProperties), $ccad6e4b6cd876c0$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $ccad6e4b6cd876c0$var$_excluded = [
    "evt"
];
var $ccad6e4b6cd876c0$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $ccad6e4b6cd876c0$var$_objectWithoutProperties(_ref, $ccad6e4b6cd876c0$var$_excluded);
    $ccad6e4b6cd876c0$var$PluginManager.pluginEvent.bind($ccad6e4b6cd876c0$export$31b3ca70d8f57423)(eventName, sortable, $ccad6e4b6cd876c0$var$_objectSpread2({
        dragEl: $ccad6e4b6cd876c0$var$dragEl,
        parentEl: $ccad6e4b6cd876c0$var$parentEl,
        ghostEl: $ccad6e4b6cd876c0$var$ghostEl,
        rootEl: $ccad6e4b6cd876c0$var$rootEl,
        nextEl: $ccad6e4b6cd876c0$var$nextEl,
        lastDownEl: $ccad6e4b6cd876c0$var$lastDownEl,
        cloneEl: $ccad6e4b6cd876c0$var$cloneEl,
        cloneHidden: $ccad6e4b6cd876c0$var$cloneHidden,
        dragStarted: $ccad6e4b6cd876c0$var$moved,
        putSortable: $ccad6e4b6cd876c0$var$putSortable,
        activeSortable: $ccad6e4b6cd876c0$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $ccad6e4b6cd876c0$var$oldIndex,
        oldDraggableIndex: $ccad6e4b6cd876c0$var$oldDraggableIndex,
        newIndex: $ccad6e4b6cd876c0$var$newIndex,
        newDraggableIndex: $ccad6e4b6cd876c0$var$newDraggableIndex,
        hideGhostForTarget: $ccad6e4b6cd876c0$var$_hideGhostForTarget,
        unhideGhostForTarget: $ccad6e4b6cd876c0$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $ccad6e4b6cd876c0$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $ccad6e4b6cd876c0$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $ccad6e4b6cd876c0$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $ccad6e4b6cd876c0$var$_dispatchEvent(info) {
    $ccad6e4b6cd876c0$var$dispatchEvent($ccad6e4b6cd876c0$var$_objectSpread2({
        putSortable: $ccad6e4b6cd876c0$var$putSortable,
        cloneEl: $ccad6e4b6cd876c0$var$cloneEl,
        targetEl: $ccad6e4b6cd876c0$var$dragEl,
        rootEl: $ccad6e4b6cd876c0$var$rootEl,
        oldIndex: $ccad6e4b6cd876c0$var$oldIndex,
        oldDraggableIndex: $ccad6e4b6cd876c0$var$oldDraggableIndex,
        newIndex: $ccad6e4b6cd876c0$var$newIndex,
        newDraggableIndex: $ccad6e4b6cd876c0$var$newDraggableIndex
    }, info));
}
var $ccad6e4b6cd876c0$var$dragEl, $ccad6e4b6cd876c0$var$parentEl, $ccad6e4b6cd876c0$var$ghostEl, $ccad6e4b6cd876c0$var$rootEl, $ccad6e4b6cd876c0$var$nextEl, $ccad6e4b6cd876c0$var$lastDownEl, $ccad6e4b6cd876c0$var$cloneEl, $ccad6e4b6cd876c0$var$cloneHidden, $ccad6e4b6cd876c0$var$oldIndex, $ccad6e4b6cd876c0$var$newIndex, $ccad6e4b6cd876c0$var$oldDraggableIndex, $ccad6e4b6cd876c0$var$newDraggableIndex, $ccad6e4b6cd876c0$var$activeGroup, $ccad6e4b6cd876c0$var$putSortable, $ccad6e4b6cd876c0$var$awaitingDragStarted = false, $ccad6e4b6cd876c0$var$ignoreNextClick = false, $ccad6e4b6cd876c0$var$sortables = [], $ccad6e4b6cd876c0$var$tapEvt, $ccad6e4b6cd876c0$var$touchEvt, $ccad6e4b6cd876c0$var$lastDx, $ccad6e4b6cd876c0$var$lastDy, $ccad6e4b6cd876c0$var$tapDistanceLeft, $ccad6e4b6cd876c0$var$tapDistanceTop, $ccad6e4b6cd876c0$var$moved, $ccad6e4b6cd876c0$var$lastTarget, $ccad6e4b6cd876c0$var$lastDirection, $ccad6e4b6cd876c0$var$pastFirstInvertThresh = false, $ccad6e4b6cd876c0$var$isCircumstantialInvert = false, $ccad6e4b6cd876c0$var$targetMoveDistance, // For positioning ghost absolutely
$ccad6e4b6cd876c0$var$ghostRelativeParent, $ccad6e4b6cd876c0$var$ghostRelativeParentInitialScroll = [], // (left, top)
$ccad6e4b6cd876c0$var$_silent = false, $ccad6e4b6cd876c0$var$savedInputChecked = [];
/** @const */ var $ccad6e4b6cd876c0$var$documentExists = typeof document !== "undefined", $ccad6e4b6cd876c0$var$PositionGhostAbsolutely = $ccad6e4b6cd876c0$var$IOS, $ccad6e4b6cd876c0$var$CSSFloatProperty = $ccad6e4b6cd876c0$var$Edge || $ccad6e4b6cd876c0$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$ccad6e4b6cd876c0$var$supportDraggable = $ccad6e4b6cd876c0$var$documentExists && !$ccad6e4b6cd876c0$var$ChromeForAndroid && !$ccad6e4b6cd876c0$var$IOS && "draggable" in document.createElement("div"), $ccad6e4b6cd876c0$var$supportCssPointerEvents = function() {
    if (!$ccad6e4b6cd876c0$var$documentExists) return; // false when <= IE11
    if ($ccad6e4b6cd876c0$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $ccad6e4b6cd876c0$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $ccad6e4b6cd876c0$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $ccad6e4b6cd876c0$var$getChild(el, 0, options), child2 = $ccad6e4b6cd876c0$var$getChild(el, 1, options), firstChildCSS = child1 && $ccad6e4b6cd876c0$var$css(child1), secondChildCSS = child2 && $ccad6e4b6cd876c0$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $ccad6e4b6cd876c0$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $ccad6e4b6cd876c0$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$ccad6e4b6cd876c0$var$CSSFloatProperty] === "none" || child2 && elCSS[$ccad6e4b6cd876c0$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $ccad6e4b6cd876c0$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */ $ccad6e4b6cd876c0$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $ccad6e4b6cd876c0$var$sortables.some(function(sortable) {
        var threshold = sortable[$ccad6e4b6cd876c0$var$expando].options.emptyInsertThreshold;
        if (!threshold || $ccad6e4b6cd876c0$var$lastChild(sortable)) return;
        var rect = $ccad6e4b6cd876c0$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $ccad6e4b6cd876c0$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $ccad6e4b6cd876c0$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $ccad6e4b6cd876c0$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$ccad6e4b6cd876c0$var$supportCssPointerEvents && $ccad6e4b6cd876c0$var$ghostEl) $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "display", "none");
}, $ccad6e4b6cd876c0$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$ccad6e4b6cd876c0$var$supportCssPointerEvents && $ccad6e4b6cd876c0$var$ghostEl) $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "display", "");
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($ccad6e4b6cd876c0$var$documentExists && !$ccad6e4b6cd876c0$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($ccad6e4b6cd876c0$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $ccad6e4b6cd876c0$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($ccad6e4b6cd876c0$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $ccad6e4b6cd876c0$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$ccad6e4b6cd876c0$var$expando]._onDragOver(event);
        }
    }
};
var $ccad6e4b6cd876c0$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($ccad6e4b6cd876c0$var$dragEl) $ccad6e4b6cd876c0$var$dragEl.parentNode[$ccad6e4b6cd876c0$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $ccad6e4b6cd876c0$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $ccad6e4b6cd876c0$var$_extends({}, options); // Export instance
    el[$ccad6e4b6cd876c0$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $ccad6e4b6cd876c0$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $ccad6e4b6cd876c0$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$ccad6e4b6cd876c0$var$Safari,
        emptyInsertThreshold: 5
    };
    $ccad6e4b6cd876c0$var$PluginManager.initializePlugins(this, el, defaults); // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $ccad6e4b6cd876c0$var$_prepareGroup(options); // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
     // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $ccad6e4b6cd876c0$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
     // Bind events
    if (options.supportPointer) $ccad6e4b6cd876c0$var$on(el, "pointerdown", this._onTapStart);
    else {
        $ccad6e4b6cd876c0$var$on(el, "mousedown", this._onTapStart);
        $ccad6e4b6cd876c0$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $ccad6e4b6cd876c0$var$on(el, "dragover", this);
        $ccad6e4b6cd876c0$var$on(el, "dragenter", this);
    }
    $ccad6e4b6cd876c0$var$sortables.push(this.el); // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager
    $ccad6e4b6cd876c0$var$_extends(this, $ccad6e4b6cd876c0$var$AnimationStateManager());
}
$ccad6e4b6cd876c0$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $ccad6e4b6cd876c0$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $ccad6e4b6cd876c0$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $ccad6e4b6cd876c0$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $ccad6e4b6cd876c0$var$_saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($ccad6e4b6cd876c0$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
         // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
         // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $ccad6e4b6cd876c0$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $ccad6e4b6cd876c0$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($ccad6e4b6cd876c0$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
         // Get the index of the dragged element within its parent
        $ccad6e4b6cd876c0$var$oldIndex = $ccad6e4b6cd876c0$var$index(target);
        $ccad6e4b6cd876c0$var$oldDraggableIndex = $ccad6e4b6cd876c0$var$index(target, options.draggable); // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $ccad6e4b6cd876c0$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $ccad6e4b6cd876c0$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $ccad6e4b6cd876c0$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $ccad6e4b6cd876c0$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $ccad6e4b6cd876c0$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$ccad6e4b6cd876c0$var$closest(originalTarget, options.handle, el, false)) return;
         // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$ccad6e4b6cd876c0$var$dragEl && target.parentNode === el) {
            var dragRect = $ccad6e4b6cd876c0$var$getRect(target);
            $ccad6e4b6cd876c0$var$rootEl = el;
            $ccad6e4b6cd876c0$var$dragEl = target;
            $ccad6e4b6cd876c0$var$parentEl = $ccad6e4b6cd876c0$var$dragEl.parentNode;
            $ccad6e4b6cd876c0$var$nextEl = $ccad6e4b6cd876c0$var$dragEl.nextSibling;
            $ccad6e4b6cd876c0$var$lastDownEl = target;
            $ccad6e4b6cd876c0$var$activeGroup = options.group;
            $ccad6e4b6cd876c0$export$31b3ca70d8f57423.dragged = $ccad6e4b6cd876c0$var$dragEl;
            $ccad6e4b6cd876c0$var$tapEvt = {
                target: $ccad6e4b6cd876c0$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $ccad6e4b6cd876c0$var$tapDistanceLeft = $ccad6e4b6cd876c0$var$tapEvt.clientX - dragRect.left;
            $ccad6e4b6cd876c0$var$tapDistanceTop = $ccad6e4b6cd876c0$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $ccad6e4b6cd876c0$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $ccad6e4b6cd876c0$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                } // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$ccad6e4b6cd876c0$var$FireFox && _this.nativeDraggable) $ccad6e4b6cd876c0$var$dragEl.draggable = true;
                 // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch); // Drag start event
                $ccad6e4b6cd876c0$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                }); // Chosen item
                $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, options.chosenClass, true);
            }; // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $ccad6e4b6cd876c0$var$find($ccad6e4b6cd876c0$var$dragEl, criteria.trim(), $ccad6e4b6cd876c0$var$_disableDraggable);
            });
            $ccad6e4b6cd876c0$var$on(ownerDocument, "dragover", $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent);
            $ccad6e4b6cd876c0$var$on(ownerDocument, "mousemove", $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent);
            $ccad6e4b6cd876c0$var$on(ownerDocument, "touchmove", $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent);
            $ccad6e4b6cd876c0$var$on(ownerDocument, "mouseup", _this._onDrop);
            $ccad6e4b6cd876c0$var$on(ownerDocument, "touchend", _this._onDrop);
            $ccad6e4b6cd876c0$var$on(ownerDocument, "touchcancel", _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)
            if ($ccad6e4b6cd876c0$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $ccad6e4b6cd876c0$var$dragEl.draggable = true;
            }
            $ccad6e4b6cd876c0$var$pluginEvent("delayStart", this, {
                evt: evt
            }); // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($ccad6e4b6cd876c0$var$Edge || $ccad6e4b6cd876c0$var$IE11OrLess))) {
                if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                } // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $ccad6e4b6cd876c0$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $ccad6e4b6cd876c0$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $ccad6e4b6cd876c0$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $ccad6e4b6cd876c0$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $ccad6e4b6cd876c0$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $ccad6e4b6cd876c0$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $ccad6e4b6cd876c0$var$dragEl && $ccad6e4b6cd876c0$var$_disableDraggable($ccad6e4b6cd876c0$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $ccad6e4b6cd876c0$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $ccad6e4b6cd876c0$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $ccad6e4b6cd876c0$var$on(document, "touchmove", this._onTouchMove);
            else $ccad6e4b6cd876c0$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $ccad6e4b6cd876c0$var$on($ccad6e4b6cd876c0$var$dragEl, "dragend", this);
            $ccad6e4b6cd876c0$var$on($ccad6e4b6cd876c0$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $ccad6e4b6cd876c0$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $ccad6e4b6cd876c0$var$awaitingDragStarted = false;
        if ($ccad6e4b6cd876c0$var$rootEl && $ccad6e4b6cd876c0$var$dragEl) {
            $ccad6e4b6cd876c0$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $ccad6e4b6cd876c0$var$on(document, "dragover", $ccad6e4b6cd876c0$var$_checkOutsideTargetEl);
            var options = this.options; // Apply effect
            !fallback && $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, options.dragClass, false);
            $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, options.ghostClass, true);
            $ccad6e4b6cd876c0$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost(); // Drag start event
            $ccad6e4b6cd876c0$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($ccad6e4b6cd876c0$var$touchEvt) {
            this._lastX = $ccad6e4b6cd876c0$var$touchEvt.clientX;
            this._lastY = $ccad6e4b6cd876c0$var$touchEvt.clientY;
            $ccad6e4b6cd876c0$var$_hideGhostForTarget();
            var target = document.elementFromPoint($ccad6e4b6cd876c0$var$touchEvt.clientX, $ccad6e4b6cd876c0$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($ccad6e4b6cd876c0$var$touchEvt.clientX, $ccad6e4b6cd876c0$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $ccad6e4b6cd876c0$var$dragEl.parentNode[$ccad6e4b6cd876c0$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$ccad6e4b6cd876c0$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$ccad6e4b6cd876c0$var$expando]._onDragOver({
                        clientX: $ccad6e4b6cd876c0$var$touchEvt.clientX,
                        clientY: $ccad6e4b6cd876c0$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $ccad6e4b6cd876c0$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($ccad6e4b6cd876c0$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $ccad6e4b6cd876c0$var$ghostEl && $ccad6e4b6cd876c0$var$matrix($ccad6e4b6cd876c0$var$ghostEl, true), scaleX = $ccad6e4b6cd876c0$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $ccad6e4b6cd876c0$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $ccad6e4b6cd876c0$var$PositionGhostAbsolutely && $ccad6e4b6cd876c0$var$ghostRelativeParent && $ccad6e4b6cd876c0$var$getRelativeScrollOffset($ccad6e4b6cd876c0$var$ghostRelativeParent), dx = (touch.clientX - $ccad6e4b6cd876c0$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $ccad6e4b6cd876c0$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $ccad6e4b6cd876c0$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $ccad6e4b6cd876c0$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging
            if (!$ccad6e4b6cd876c0$export$31b3ca70d8f57423.active && !$ccad6e4b6cd876c0$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($ccad6e4b6cd876c0$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($ccad6e4b6cd876c0$var$lastDx || 0);
                    ghostMatrix.f += dy - ($ccad6e4b6cd876c0$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "webkitTransform", cssMatrix);
                $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "mozTransform", cssMatrix);
                $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "msTransform", cssMatrix);
                $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "transform", cssMatrix);
                $ccad6e4b6cd876c0$var$lastDx = dx;
                $ccad6e4b6cd876c0$var$lastDy = dy;
                $ccad6e4b6cd876c0$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$ccad6e4b6cd876c0$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $ccad6e4b6cd876c0$var$rootEl, rect = $ccad6e4b6cd876c0$var$getRect($ccad6e4b6cd876c0$var$dragEl, true, $ccad6e4b6cd876c0$var$PositionGhostAbsolutely, true, container), options = this.options; // Position absolutely
            if ($ccad6e4b6cd876c0$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $ccad6e4b6cd876c0$var$ghostRelativeParent = container;
                while($ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostRelativeParent, "position") === "static" && $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostRelativeParent, "transform") === "none" && $ccad6e4b6cd876c0$var$ghostRelativeParent !== document)$ccad6e4b6cd876c0$var$ghostRelativeParent = $ccad6e4b6cd876c0$var$ghostRelativeParent.parentNode;
                if ($ccad6e4b6cd876c0$var$ghostRelativeParent !== document.body && $ccad6e4b6cd876c0$var$ghostRelativeParent !== document.documentElement) {
                    if ($ccad6e4b6cd876c0$var$ghostRelativeParent === document) $ccad6e4b6cd876c0$var$ghostRelativeParent = $ccad6e4b6cd876c0$var$getWindowScrollingElement();
                    rect.top += $ccad6e4b6cd876c0$var$ghostRelativeParent.scrollTop;
                    rect.left += $ccad6e4b6cd876c0$var$ghostRelativeParent.scrollLeft;
                } else $ccad6e4b6cd876c0$var$ghostRelativeParent = $ccad6e4b6cd876c0$var$getWindowScrollingElement();
                $ccad6e4b6cd876c0$var$ghostRelativeParentInitialScroll = $ccad6e4b6cd876c0$var$getRelativeScrollOffset($ccad6e4b6cd876c0$var$ghostRelativeParent);
            }
            $ccad6e4b6cd876c0$var$ghostEl = $ccad6e4b6cd876c0$var$dragEl.cloneNode(true);
            $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$ghostEl, options.ghostClass, false);
            $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$ghostEl, options.fallbackClass, true);
            $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$ghostEl, options.dragClass, true);
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "transition", "");
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "transform", "");
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "box-sizing", "border-box");
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "margin", 0);
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "top", rect.top);
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "left", rect.left);
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "width", rect.width);
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "height", rect.height);
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "opacity", "0.8");
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "position", $ccad6e4b6cd876c0$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "zIndex", "100000");
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "pointerEvents", "none");
            $ccad6e4b6cd876c0$export$31b3ca70d8f57423.ghost = $ccad6e4b6cd876c0$var$ghostEl;
            container.appendChild($ccad6e4b6cd876c0$var$ghostEl); // Set transform-origin
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$ghostEl, "transform-origin", $ccad6e4b6cd876c0$var$tapDistanceLeft / parseInt($ccad6e4b6cd876c0$var$ghostEl.style.width) * 100 + "% " + $ccad6e4b6cd876c0$var$tapDistanceTop / parseInt($ccad6e4b6cd876c0$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $ccad6e4b6cd876c0$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $ccad6e4b6cd876c0$var$pluginEvent("setupClone", this);
        if (!$ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) {
            $ccad6e4b6cd876c0$var$cloneEl = $ccad6e4b6cd876c0$var$clone($ccad6e4b6cd876c0$var$dragEl);
            $ccad6e4b6cd876c0$var$cloneEl.removeAttribute("id");
            $ccad6e4b6cd876c0$var$cloneEl.draggable = false;
            $ccad6e4b6cd876c0$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$cloneEl, this.options.chosenClass, false);
            $ccad6e4b6cd876c0$export$31b3ca70d8f57423.clone = $ccad6e4b6cd876c0$var$cloneEl;
        } // #1143: IFrame support workaround
        _this.cloneId = $ccad6e4b6cd876c0$var$_nextTick(function() {
            $ccad6e4b6cd876c0$var$pluginEvent("clone", _this);
            if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $ccad6e4b6cd876c0$var$rootEl.insertBefore($ccad6e4b6cd876c0$var$cloneEl, $ccad6e4b6cd876c0$var$dragEl);
            _this._hideClone();
            $ccad6e4b6cd876c0$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, options.dragClass, true); // Set proper drop events
        if (fallback) {
            $ccad6e4b6cd876c0$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $ccad6e4b6cd876c0$var$off(document, "mouseup", _this._onDrop);
            $ccad6e4b6cd876c0$var$off(document, "touchend", _this._onDrop);
            $ccad6e4b6cd876c0$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $ccad6e4b6cd876c0$var$dragEl);
            }
            $ccad6e4b6cd876c0$var$on(document, "drop", _this); // #1276 fix:
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$dragEl, "transform", "translateZ(0)");
        }
        $ccad6e4b6cd876c0$var$awaitingDragStarted = true;
        _this._dragStartId = $ccad6e4b6cd876c0$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $ccad6e4b6cd876c0$var$on(document, "selectstart", _this);
        $ccad6e4b6cd876c0$var$moved = true;
        if ($ccad6e4b6cd876c0$var$Safari) $ccad6e4b6cd876c0$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $ccad6e4b6cd876c0$export$31b3ca70d8f57423.active, isOwner = $ccad6e4b6cd876c0$var$activeGroup === group, canSort = options.sort, fromSortable = $ccad6e4b6cd876c0$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($ccad6e4b6cd876c0$var$_silent) return;
        function dragOverEvent(name, extra) {
            $ccad6e4b6cd876c0$var$pluginEvent(name, _this, $ccad6e4b6cd876c0$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $ccad6e4b6cd876c0$var$_onMove($ccad6e4b6cd876c0$var$rootEl, el, $ccad6e4b6cd876c0$var$dragEl, dragRect, target, $ccad6e4b6cd876c0$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        } // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        } // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, $ccad6e4b6cd876c0$var$putSortable ? $ccad6e4b6cd876c0$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, options.ghostClass, true);
                }
                if ($ccad6e4b6cd876c0$var$putSortable !== _this && _this !== $ccad6e4b6cd876c0$export$31b3ca70d8f57423.active) $ccad6e4b6cd876c0$var$putSortable = _this;
                else if (_this === $ccad6e4b6cd876c0$export$31b3ca70d8f57423.active && $ccad6e4b6cd876c0$var$putSortable) $ccad6e4b6cd876c0$var$putSortable = null;
                 // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            } // Null lastTarget if it is not inside a previously swapped element
            if (target === $ccad6e4b6cd876c0$var$dragEl && !$ccad6e4b6cd876c0$var$dragEl.animated || target === el && !target.animated) $ccad6e4b6cd876c0$var$lastTarget = null;
             // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $ccad6e4b6cd876c0$var$dragEl.parentNode[$ccad6e4b6cd876c0$var$expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted
                !insertion && $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        } // Call when dragEl has been inserted
        function changed() {
            $ccad6e4b6cd876c0$var$newIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl);
            $ccad6e4b6cd876c0$var$newDraggableIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl, options.draggable);
            $ccad6e4b6cd876c0$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $ccad6e4b6cd876c0$var$newIndex,
                newDraggableIndex: $ccad6e4b6cd876c0$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $ccad6e4b6cd876c0$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($ccad6e4b6cd876c0$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $ccad6e4b6cd876c0$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $ccad6e4b6cd876c0$var$parentEl !== $ccad6e4b6cd876c0$var$rootEl // Reverting item into the original list
        ) : $ccad6e4b6cd876c0$var$putSortable === this || (this.lastPutMode = $ccad6e4b6cd876c0$var$activeGroup.checkPull(this, activeSortable, $ccad6e4b6cd876c0$var$dragEl, evt)) && group.checkPut(this, activeSortable, $ccad6e4b6cd876c0$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $ccad6e4b6cd876c0$var$getRect($ccad6e4b6cd876c0$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $ccad6e4b6cd876c0$var$parentEl = $ccad6e4b6cd876c0$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) {
                    if ($ccad6e4b6cd876c0$var$nextEl) $ccad6e4b6cd876c0$var$rootEl.insertBefore($ccad6e4b6cd876c0$var$dragEl, $ccad6e4b6cd876c0$var$nextEl);
                    else $ccad6e4b6cd876c0$var$rootEl.appendChild($ccad6e4b6cd876c0$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $ccad6e4b6cd876c0$var$lastChild(el, options.draggable);
            if (!elLastChild || $ccad6e4b6cd876c0$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $ccad6e4b6cd876c0$var$dragEl) return completed(false);
                 // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $ccad6e4b6cd876c0$var$getRect(target);
                if ($ccad6e4b6cd876c0$var$_onMove($ccad6e4b6cd876c0$var$rootEl, el, $ccad6e4b6cd876c0$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($ccad6e4b6cd876c0$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($ccad6e4b6cd876c0$var$dragEl);
                    $ccad6e4b6cd876c0$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $ccad6e4b6cd876c0$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $ccad6e4b6cd876c0$var$getChild(el, 0, options, true);
                if (firstChild === $ccad6e4b6cd876c0$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $ccad6e4b6cd876c0$var$getRect(target);
                if ($ccad6e4b6cd876c0$var$_onMove($ccad6e4b6cd876c0$var$rootEl, el, $ccad6e4b6cd876c0$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($ccad6e4b6cd876c0$var$dragEl, firstChild);
                    $ccad6e4b6cd876c0$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $ccad6e4b6cd876c0$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $ccad6e4b6cd876c0$var$dragEl.parentNode !== el, differentRowCol = !$ccad6e4b6cd876c0$var$_dragElInRowColumn($ccad6e4b6cd876c0$var$dragEl.animated && $ccad6e4b6cd876c0$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $ccad6e4b6cd876c0$var$isScrolledPast(target, "top", "top") || $ccad6e4b6cd876c0$var$isScrolledPast($ccad6e4b6cd876c0$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($ccad6e4b6cd876c0$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $ccad6e4b6cd876c0$var$pastFirstInvertThresh = false;
                    $ccad6e4b6cd876c0$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $ccad6e4b6cd876c0$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $ccad6e4b6cd876c0$var$isCircumstantialInvert, $ccad6e4b6cd876c0$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $ccad6e4b6cd876c0$var$parentEl.children[dragIndex];
                    }while (sibling && ($ccad6e4b6cd876c0$var$css(sibling, "display") === "none" || sibling === $ccad6e4b6cd876c0$var$ghostEl));
                } // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $ccad6e4b6cd876c0$var$lastTarget = target;
                $ccad6e4b6cd876c0$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $ccad6e4b6cd876c0$var$_onMove($ccad6e4b6cd876c0$var$rootEl, el, $ccad6e4b6cd876c0$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $ccad6e4b6cd876c0$var$_silent = true;
                    setTimeout($ccad6e4b6cd876c0$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($ccad6e4b6cd876c0$var$dragEl);
                    else target.parentNode.insertBefore($ccad6e4b6cd876c0$var$dragEl, after ? nextSibling : target);
                     // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $ccad6e4b6cd876c0$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $ccad6e4b6cd876c0$var$parentEl = $ccad6e4b6cd876c0$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$ccad6e4b6cd876c0$var$isCircumstantialInvert) $ccad6e4b6cd876c0$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $ccad6e4b6cd876c0$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($ccad6e4b6cd876c0$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $ccad6e4b6cd876c0$var$off(document, "mousemove", this._onTouchMove);
        $ccad6e4b6cd876c0$var$off(document, "touchmove", this._onTouchMove);
        $ccad6e4b6cd876c0$var$off(document, "pointermove", this._onTouchMove);
        $ccad6e4b6cd876c0$var$off(document, "dragover", $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent);
        $ccad6e4b6cd876c0$var$off(document, "mousemove", $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent);
        $ccad6e4b6cd876c0$var$off(document, "touchmove", $ccad6e4b6cd876c0$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $ccad6e4b6cd876c0$var$off(ownerDocument, "mouseup", this._onDrop);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "touchend", this._onDrop);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "pointerup", this._onDrop);
        $ccad6e4b6cd876c0$var$off(ownerDocument, "touchcancel", this._onDrop);
        $ccad6e4b6cd876c0$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options; // Get the index of the dragged element within its parent
        $ccad6e4b6cd876c0$var$newIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl);
        $ccad6e4b6cd876c0$var$newDraggableIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl, options.draggable);
        $ccad6e4b6cd876c0$var$pluginEvent("drop", this, {
            evt: evt
        });
        $ccad6e4b6cd876c0$var$parentEl = $ccad6e4b6cd876c0$var$dragEl && $ccad6e4b6cd876c0$var$dragEl.parentNode; // Get again after plugin event
        $ccad6e4b6cd876c0$var$newIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl);
        $ccad6e4b6cd876c0$var$newDraggableIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl, options.draggable);
        if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $ccad6e4b6cd876c0$var$awaitingDragStarted = false;
        $ccad6e4b6cd876c0$var$isCircumstantialInvert = false;
        $ccad6e4b6cd876c0$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $ccad6e4b6cd876c0$var$_cancelNextTick(this.cloneId);
        $ccad6e4b6cd876c0$var$_cancelNextTick(this._dragStartId); // Unbind events
        if (this.nativeDraggable) {
            $ccad6e4b6cd876c0$var$off(document, "drop", this);
            $ccad6e4b6cd876c0$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($ccad6e4b6cd876c0$var$Safari) $ccad6e4b6cd876c0$var$css(document.body, "user-select", "");
        $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$dragEl, "transform", "");
        if (evt) {
            if ($ccad6e4b6cd876c0$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $ccad6e4b6cd876c0$var$ghostEl && $ccad6e4b6cd876c0$var$ghostEl.parentNode && $ccad6e4b6cd876c0$var$ghostEl.parentNode.removeChild($ccad6e4b6cd876c0$var$ghostEl);
            if ($ccad6e4b6cd876c0$var$rootEl === $ccad6e4b6cd876c0$var$parentEl || $ccad6e4b6cd876c0$var$putSortable && $ccad6e4b6cd876c0$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $ccad6e4b6cd876c0$var$cloneEl && $ccad6e4b6cd876c0$var$cloneEl.parentNode && $ccad6e4b6cd876c0$var$cloneEl.parentNode.removeChild($ccad6e4b6cd876c0$var$cloneEl);
            if ($ccad6e4b6cd876c0$var$dragEl) {
                if (this.nativeDraggable) $ccad6e4b6cd876c0$var$off($ccad6e4b6cd876c0$var$dragEl, "dragend", this);
                $ccad6e4b6cd876c0$var$_disableDraggable($ccad6e4b6cd876c0$var$dragEl);
                $ccad6e4b6cd876c0$var$dragEl.style["will-change"] = ""; // Remove classes
                // ghostClass is added in dragStarted
                if ($ccad6e4b6cd876c0$var$moved && !$ccad6e4b6cd876c0$var$awaitingDragStarted) $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, $ccad6e4b6cd876c0$var$putSortable ? $ccad6e4b6cd876c0$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl, this.options.chosenClass, false); // Drag stop event
                $ccad6e4b6cd876c0$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $ccad6e4b6cd876c0$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($ccad6e4b6cd876c0$var$rootEl !== $ccad6e4b6cd876c0$var$parentEl) {
                    if ($ccad6e4b6cd876c0$var$newIndex >= 0) {
                        // Add event
                        $ccad6e4b6cd876c0$var$_dispatchEvent({
                            rootEl: $ccad6e4b6cd876c0$var$parentEl,
                            name: "add",
                            toEl: $ccad6e4b6cd876c0$var$parentEl,
                            fromEl: $ccad6e4b6cd876c0$var$rootEl,
                            originalEvent: evt
                        }); // Remove event
                        $ccad6e4b6cd876c0$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $ccad6e4b6cd876c0$var$parentEl,
                            originalEvent: evt
                        }); // drag from one list and drop into another
                        $ccad6e4b6cd876c0$var$_dispatchEvent({
                            rootEl: $ccad6e4b6cd876c0$var$parentEl,
                            name: "sort",
                            toEl: $ccad6e4b6cd876c0$var$parentEl,
                            fromEl: $ccad6e4b6cd876c0$var$rootEl,
                            originalEvent: evt
                        });
                        $ccad6e4b6cd876c0$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $ccad6e4b6cd876c0$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $ccad6e4b6cd876c0$var$putSortable && $ccad6e4b6cd876c0$var$putSortable.save();
                } else {
                    if ($ccad6e4b6cd876c0$var$newIndex !== $ccad6e4b6cd876c0$var$oldIndex) {
                        if ($ccad6e4b6cd876c0$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $ccad6e4b6cd876c0$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $ccad6e4b6cd876c0$var$parentEl,
                                originalEvent: evt
                            });
                            $ccad6e4b6cd876c0$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $ccad6e4b6cd876c0$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($ccad6e4b6cd876c0$var$newIndex == null || $ccad6e4b6cd876c0$var$newIndex === -1) {
                        $ccad6e4b6cd876c0$var$newIndex = $ccad6e4b6cd876c0$var$oldIndex;
                        $ccad6e4b6cd876c0$var$newDraggableIndex = $ccad6e4b6cd876c0$var$oldDraggableIndex;
                    }
                    $ccad6e4b6cd876c0$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $ccad6e4b6cd876c0$var$parentEl,
                        originalEvent: evt
                    }); // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $ccad6e4b6cd876c0$var$pluginEvent("nulling", this);
        $ccad6e4b6cd876c0$var$rootEl = $ccad6e4b6cd876c0$var$dragEl = $ccad6e4b6cd876c0$var$parentEl = $ccad6e4b6cd876c0$var$ghostEl = $ccad6e4b6cd876c0$var$nextEl = $ccad6e4b6cd876c0$var$cloneEl = $ccad6e4b6cd876c0$var$lastDownEl = $ccad6e4b6cd876c0$var$cloneHidden = $ccad6e4b6cd876c0$var$tapEvt = $ccad6e4b6cd876c0$var$touchEvt = $ccad6e4b6cd876c0$var$moved = $ccad6e4b6cd876c0$var$newIndex = $ccad6e4b6cd876c0$var$newDraggableIndex = $ccad6e4b6cd876c0$var$oldIndex = $ccad6e4b6cd876c0$var$oldDraggableIndex = $ccad6e4b6cd876c0$var$lastTarget = $ccad6e4b6cd876c0$var$lastDirection = $ccad6e4b6cd876c0$var$putSortable = $ccad6e4b6cd876c0$var$activeGroup = $ccad6e4b6cd876c0$export$31b3ca70d8f57423.dragged = $ccad6e4b6cd876c0$export$31b3ca70d8f57423.ghost = $ccad6e4b6cd876c0$export$31b3ca70d8f57423.clone = $ccad6e4b6cd876c0$export$31b3ca70d8f57423.active = null;
        $ccad6e4b6cd876c0$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $ccad6e4b6cd876c0$var$savedInputChecked.length = $ccad6e4b6cd876c0$var$lastDx = $ccad6e4b6cd876c0$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($ccad6e4b6cd876c0$var$dragEl) {
                    this._onDragOver(evt);
                    $ccad6e4b6cd876c0$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($ccad6e4b6cd876c0$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $ccad6e4b6cd876c0$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($ccad6e4b6cd876c0$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $ccad6e4b6cd876c0$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $ccad6e4b6cd876c0$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $ccad6e4b6cd876c0$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $ccad6e4b6cd876c0$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$ccad6e4b6cd876c0$var$expando] = null;
        $ccad6e4b6cd876c0$var$off(el, "mousedown", this._onTapStart);
        $ccad6e4b6cd876c0$var$off(el, "touchstart", this._onTapStart);
        $ccad6e4b6cd876c0$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $ccad6e4b6cd876c0$var$off(el, "dragover", this);
            $ccad6e4b6cd876c0$var$off(el, "dragenter", this);
        } // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $ccad6e4b6cd876c0$var$sortables.splice($ccad6e4b6cd876c0$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$ccad6e4b6cd876c0$var$cloneHidden) {
            $ccad6e4b6cd876c0$var$pluginEvent("hideClone", this);
            if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) return;
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $ccad6e4b6cd876c0$var$cloneEl.parentNode) $ccad6e4b6cd876c0$var$cloneEl.parentNode.removeChild($ccad6e4b6cd876c0$var$cloneEl);
            $ccad6e4b6cd876c0$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($ccad6e4b6cd876c0$var$cloneHidden) {
            $ccad6e4b6cd876c0$var$pluginEvent("showClone", this);
            if ($ccad6e4b6cd876c0$export$31b3ca70d8f57423.eventCanceled) return; // show clone at dragEl or original position
            if ($ccad6e4b6cd876c0$var$dragEl.parentNode == $ccad6e4b6cd876c0$var$rootEl && !this.options.group.revertClone) $ccad6e4b6cd876c0$var$rootEl.insertBefore($ccad6e4b6cd876c0$var$cloneEl, $ccad6e4b6cd876c0$var$dragEl);
            else if ($ccad6e4b6cd876c0$var$nextEl) $ccad6e4b6cd876c0$var$rootEl.insertBefore($ccad6e4b6cd876c0$var$cloneEl, $ccad6e4b6cd876c0$var$nextEl);
            else $ccad6e4b6cd876c0$var$rootEl.appendChild($ccad6e4b6cd876c0$var$cloneEl);
            if (this.options.group.revertClone) this.animate($ccad6e4b6cd876c0$var$dragEl, $ccad6e4b6cd876c0$var$cloneEl);
            $ccad6e4b6cd876c0$var$css($ccad6e4b6cd876c0$var$cloneEl, "display", "");
            $ccad6e4b6cd876c0$var$cloneHidden = false;
        }
    }
};
function $ccad6e4b6cd876c0$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $ccad6e4b6cd876c0$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$ccad6e4b6cd876c0$var$expando], onMoveFn = sortable.options.onMove, retVal; // Support for new CustomEvent feature
    if (window.CustomEvent && !$ccad6e4b6cd876c0$var$IE11OrLess && !$ccad6e4b6cd876c0$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $ccad6e4b6cd876c0$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $ccad6e4b6cd876c0$var$_disableDraggable(el) {
    el.draggable = false;
}
function $ccad6e4b6cd876c0$var$_unsilent() {
    $ccad6e4b6cd876c0$var$_silent = false;
}
function $ccad6e4b6cd876c0$var$_ghostIsFirst(evt, vertical, sortable) {
    var rect = $ccad6e4b6cd876c0$var$getRect($ccad6e4b6cd876c0$var$getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function $ccad6e4b6cd876c0$var$_ghostIsLast(evt, vertical, sortable) {
    var rect = $ccad6e4b6cd876c0$var$getRect($ccad6e4b6cd876c0$var$lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function $ccad6e4b6cd876c0$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $ccad6e4b6cd876c0$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$ccad6e4b6cd876c0$var$pastFirstInvertThresh && ($ccad6e4b6cd876c0$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $ccad6e4b6cd876c0$var$pastFirstInvertThresh = true;
            if (!$ccad6e4b6cd876c0$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($ccad6e4b6cd876c0$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $ccad6e4b6cd876c0$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $ccad6e4b6cd876c0$var$targetMoveDistance) return -$ccad6e4b6cd876c0$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $ccad6e4b6cd876c0$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $ccad6e4b6cd876c0$var$_getInsertDirection(target) {
    if ($ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl) < $ccad6e4b6cd876c0$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $ccad6e4b6cd876c0$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $ccad6e4b6cd876c0$var$_saveInputCheckedState(root) {
    $ccad6e4b6cd876c0$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $ccad6e4b6cd876c0$var$savedInputChecked.push(el);
    }
}
function $ccad6e4b6cd876c0$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $ccad6e4b6cd876c0$var$_cancelNextTick(id) {
    return clearTimeout(id);
} // Fixed #973:
if ($ccad6e4b6cd876c0$var$documentExists) $ccad6e4b6cd876c0$var$on(document, "touchmove", function(evt) {
    if (($ccad6e4b6cd876c0$export$31b3ca70d8f57423.active || $ccad6e4b6cd876c0$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
 // Export utils
$ccad6e4b6cd876c0$export$31b3ca70d8f57423.utils = {
    on: $ccad6e4b6cd876c0$var$on,
    off: $ccad6e4b6cd876c0$var$off,
    css: $ccad6e4b6cd876c0$var$css,
    find: $ccad6e4b6cd876c0$var$find,
    is: function is(el, selector) {
        return !!$ccad6e4b6cd876c0$var$closest(el, selector, el, false);
    },
    extend: $ccad6e4b6cd876c0$var$extend,
    throttle: $ccad6e4b6cd876c0$var$throttle,
    closest: $ccad6e4b6cd876c0$var$closest,
    toggleClass: $ccad6e4b6cd876c0$var$toggleClass,
    clone: $ccad6e4b6cd876c0$var$clone,
    index: $ccad6e4b6cd876c0$var$index,
    nextTick: $ccad6e4b6cd876c0$var$_nextTick,
    cancelNextTick: $ccad6e4b6cd876c0$var$_cancelNextTick,
    detectDirection: $ccad6e4b6cd876c0$var$_detectDirection,
    getChild: $ccad6e4b6cd876c0$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $ccad6e4b6cd876c0$export$31b3ca70d8f57423.get = function(element) {
    return element[$ccad6e4b6cd876c0$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $ccad6e4b6cd876c0$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $ccad6e4b6cd876c0$export$31b3ca70d8f57423.utils = $ccad6e4b6cd876c0$var$_objectSpread2($ccad6e4b6cd876c0$var$_objectSpread2({}, $ccad6e4b6cd876c0$export$31b3ca70d8f57423.utils), plugin.utils);
        $ccad6e4b6cd876c0$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $ccad6e4b6cd876c0$export$31b3ca70d8f57423.create = function(el, options) {
    return new $ccad6e4b6cd876c0$export$31b3ca70d8f57423(el, options);
}; // Export
$ccad6e4b6cd876c0$export$31b3ca70d8f57423.version = $ccad6e4b6cd876c0$var$version;
var $ccad6e4b6cd876c0$var$autoScrolls = [], $ccad6e4b6cd876c0$var$scrollEl, $ccad6e4b6cd876c0$var$scrollRootEl, $ccad6e4b6cd876c0$var$scrolling = false, $ccad6e4b6cd876c0$var$lastAutoScrollX, $ccad6e4b6cd876c0$var$lastAutoScrollY, $ccad6e4b6cd876c0$var$touchEvt$1, $ccad6e4b6cd876c0$var$pointerElemChangedInterval;
function $ccad6e4b6cd876c0$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        }; // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $ccad6e4b6cd876c0$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $ccad6e4b6cd876c0$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $ccad6e4b6cd876c0$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $ccad6e4b6cd876c0$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $ccad6e4b6cd876c0$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $ccad6e4b6cd876c0$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $ccad6e4b6cd876c0$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $ccad6e4b6cd876c0$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $ccad6e4b6cd876c0$var$clearPointerElemChangedInterval();
            $ccad6e4b6cd876c0$var$clearAutoScrolls();
            $ccad6e4b6cd876c0$var$cancelThrottle();
        },
        nulling: function nulling() {
            $ccad6e4b6cd876c0$var$touchEvt$1 = $ccad6e4b6cd876c0$var$scrollRootEl = $ccad6e4b6cd876c0$var$scrollEl = $ccad6e4b6cd876c0$var$scrolling = $ccad6e4b6cd876c0$var$pointerElemChangedInterval = $ccad6e4b6cd876c0$var$lastAutoScrollX = $ccad6e4b6cd876c0$var$lastAutoScrollY = null;
            $ccad6e4b6cd876c0$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $ccad6e4b6cd876c0$var$touchEvt$1 = evt; // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $ccad6e4b6cd876c0$var$Edge || $ccad6e4b6cd876c0$var$IE11OrLess || $ccad6e4b6cd876c0$var$Safari) {
                $ccad6e4b6cd876c0$var$autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change
                var ogElemScroller = $ccad6e4b6cd876c0$var$getParentAutoScrollElement(elem, true);
                if ($ccad6e4b6cd876c0$var$scrolling && (!$ccad6e4b6cd876c0$var$pointerElemChangedInterval || x !== $ccad6e4b6cd876c0$var$lastAutoScrollX || y !== $ccad6e4b6cd876c0$var$lastAutoScrollY)) {
                    $ccad6e4b6cd876c0$var$pointerElemChangedInterval && $ccad6e4b6cd876c0$var$clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour
                    $ccad6e4b6cd876c0$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $ccad6e4b6cd876c0$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $ccad6e4b6cd876c0$var$clearAutoScrolls();
                        }
                        $ccad6e4b6cd876c0$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $ccad6e4b6cd876c0$var$lastAutoScrollX = x;
                    $ccad6e4b6cd876c0$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $ccad6e4b6cd876c0$var$getParentAutoScrollElement(elem, true) === $ccad6e4b6cd876c0$var$getWindowScrollingElement()) {
                    $ccad6e4b6cd876c0$var$clearAutoScrolls();
                    return;
                }
                $ccad6e4b6cd876c0$var$autoScroll(evt, this.options, $ccad6e4b6cd876c0$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $ccad6e4b6cd876c0$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $ccad6e4b6cd876c0$var$clearAutoScrolls() {
    $ccad6e4b6cd876c0$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $ccad6e4b6cd876c0$var$autoScrolls = [];
}
function $ccad6e4b6cd876c0$var$clearPointerElemChangedInterval() {
    clearInterval($ccad6e4b6cd876c0$var$pointerElemChangedInterval);
}
var $ccad6e4b6cd876c0$var$autoScroll = $ccad6e4b6cd876c0$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $ccad6e4b6cd876c0$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn; // New scroll root, set scrollEl
    if ($ccad6e4b6cd876c0$var$scrollRootEl !== rootEl) {
        $ccad6e4b6cd876c0$var$scrollRootEl = rootEl;
        $ccad6e4b6cd876c0$var$clearAutoScrolls();
        $ccad6e4b6cd876c0$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($ccad6e4b6cd876c0$var$scrollEl === true) $ccad6e4b6cd876c0$var$scrollEl = $ccad6e4b6cd876c0$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $ccad6e4b6cd876c0$var$scrollEl;
    do {
        var el = currentParent, rect = $ccad6e4b6cd876c0$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $ccad6e4b6cd876c0$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$ccad6e4b6cd876c0$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$ccad6e4b6cd876c0$var$autoScrolls[i]) $ccad6e4b6cd876c0$var$autoScrolls[i] = {};
        }
        if ($ccad6e4b6cd876c0$var$autoScrolls[layersOut].vx != vx || $ccad6e4b6cd876c0$var$autoScrolls[layersOut].vy != vy || $ccad6e4b6cd876c0$var$autoScrolls[layersOut].el !== el) {
            $ccad6e4b6cd876c0$var$autoScrolls[layersOut].el = el;
            $ccad6e4b6cd876c0$var$autoScrolls[layersOut].vx = vx;
            $ccad6e4b6cd876c0$var$autoScrolls[layersOut].vy = vy;
            clearInterval($ccad6e4b6cd876c0$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $ccad6e4b6cd876c0$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $ccad6e4b6cd876c0$export$31b3ca70d8f57423.active._onTouchMove($ccad6e4b6cd876c0$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $ccad6e4b6cd876c0$var$autoScrolls[this.layer].vy ? $ccad6e4b6cd876c0$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $ccad6e4b6cd876c0$var$autoScrolls[this.layer].vx ? $ccad6e4b6cd876c0$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($ccad6e4b6cd876c0$export$31b3ca70d8f57423.dragged.parentNode[$ccad6e4b6cd876c0$var$expando], scrollOffsetX, scrollOffsetY, evt, $ccad6e4b6cd876c0$var$touchEvt$1, $ccad6e4b6cd876c0$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $ccad6e4b6cd876c0$var$scrollBy($ccad6e4b6cd876c0$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $ccad6e4b6cd876c0$var$getParentAutoScrollElement(currentParent, false)));
    $ccad6e4b6cd876c0$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $ccad6e4b6cd876c0$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $ccad6e4b6cd876c0$var$Revert() {}
$ccad6e4b6cd876c0$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $ccad6e4b6cd876c0$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $ccad6e4b6cd876c0$var$drop
};
$ccad6e4b6cd876c0$var$_extends($ccad6e4b6cd876c0$var$Revert, {
    pluginName: "revertOnSpill"
});
function $ccad6e4b6cd876c0$var$Remove() {}
$ccad6e4b6cd876c0$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $ccad6e4b6cd876c0$var$drop
};
$ccad6e4b6cd876c0$var$_extends($ccad6e4b6cd876c0$var$Remove, {
    pluginName: "removeOnSpill"
});
var $ccad6e4b6cd876c0$var$lastSwapEl;
function $ccad6e4b6cd876c0$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $ccad6e4b6cd876c0$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $ccad6e4b6cd876c0$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $ccad6e4b6cd876c0$var$toggleClass(target, options.swapClass, true);
                    $ccad6e4b6cd876c0$var$lastSwapEl = target;
                } else $ccad6e4b6cd876c0$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $ccad6e4b6cd876c0$var$lastSwapEl) $ccad6e4b6cd876c0$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $ccad6e4b6cd876c0$var$lastSwapEl && $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$lastSwapEl, options.swapClass, false);
            if ($ccad6e4b6cd876c0$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $ccad6e4b6cd876c0$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $ccad6e4b6cd876c0$var$swapNodes(dragEl, $ccad6e4b6cd876c0$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $ccad6e4b6cd876c0$var$lastSwapEl = null;
        }
    };
    return $ccad6e4b6cd876c0$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $ccad6e4b6cd876c0$var$lastSwapEl
            };
        }
    });
}
function $ccad6e4b6cd876c0$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $ccad6e4b6cd876c0$var$index(n1);
    i2 = $ccad6e4b6cd876c0$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $ccad6e4b6cd876c0$var$multiDragElements = [], $ccad6e4b6cd876c0$var$multiDragClones = [], $ccad6e4b6cd876c0$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$ccad6e4b6cd876c0$var$multiDragSortable, $ccad6e4b6cd876c0$var$initialFolding = false, // Initial multi-drag fold when drag started
$ccad6e4b6cd876c0$var$folding = false, // Folding any other time
$ccad6e4b6cd876c0$var$dragStarted = false, $ccad6e4b6cd876c0$var$dragEl$1, $ccad6e4b6cd876c0$var$clonesFromRect, $ccad6e4b6cd876c0$var$clonesHidden;
function $ccad6e4b6cd876c0$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $ccad6e4b6cd876c0$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $ccad6e4b6cd876c0$var$on(document, "mouseup", this._deselectMultiDrag);
                $ccad6e4b6cd876c0$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $ccad6e4b6cd876c0$var$on(document, "keydown", this._checkKeyDown);
        $ccad6e4b6cd876c0$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($ccad6e4b6cd876c0$var$multiDragElements.length && $ccad6e4b6cd876c0$var$multiDragSortable === sortable) $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $ccad6e4b6cd876c0$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$ccad6e4b6cd876c0$var$multiDragElements.indexOf($ccad6e4b6cd876c0$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $ccad6e4b6cd876c0$var$multiDragElements.length; i++){
                $ccad6e4b6cd876c0$var$multiDragClones.push($ccad6e4b6cd876c0$var$clone($ccad6e4b6cd876c0$var$multiDragElements[i]));
                $ccad6e4b6cd876c0$var$multiDragClones[i].sortableIndex = $ccad6e4b6cd876c0$var$multiDragElements[i].sortableIndex;
                $ccad6e4b6cd876c0$var$multiDragClones[i].draggable = false;
                $ccad6e4b6cd876c0$var$multiDragClones[i].style["will-change"] = "";
                $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$multiDragClones[i], this.options.selectedClass, false);
                $ccad6e4b6cd876c0$var$multiDragElements[i] === $ccad6e4b6cd876c0$var$dragEl$1 && $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($ccad6e4b6cd876c0$var$multiDragElements.length && $ccad6e4b6cd876c0$var$multiDragSortable === sortable) {
                    $ccad6e4b6cd876c0$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $ccad6e4b6cd876c0$var$insertMultiDragClones(false, rootEl);
            $ccad6e4b6cd876c0$var$multiDragClones.forEach(function(clone) {
                $ccad6e4b6cd876c0$var$css(clone, "display", "");
            });
            cloneNowShown();
            $ccad6e4b6cd876c0$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $ccad6e4b6cd876c0$var$multiDragClones.forEach(function(clone) {
                $ccad6e4b6cd876c0$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $ccad6e4b6cd876c0$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $ccad6e4b6cd876c0$var$multiDragSortable) $ccad6e4b6cd876c0$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $ccad6e4b6cd876c0$var$index(multiDragElement);
            }); // Sort multi-drag elements
            $ccad6e4b6cd876c0$var$multiDragElements = $ccad6e4b6cd876c0$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $ccad6e4b6cd876c0$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $ccad6e4b6cd876c0$var$dragEl$1) return;
                        $ccad6e4b6cd876c0$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $ccad6e4b6cd876c0$var$getRect($ccad6e4b6cd876c0$var$dragEl$1, false, true, true);
                    $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $ccad6e4b6cd876c0$var$dragEl$1) return;
                        $ccad6e4b6cd876c0$var$setRect(multiDragElement, dragRect);
                    });
                    $ccad6e4b6cd876c0$var$folding = true;
                    $ccad6e4b6cd876c0$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $ccad6e4b6cd876c0$var$folding = false;
                $ccad6e4b6cd876c0$var$initialFolding = false;
                if (_this2.options.animation) $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                    $ccad6e4b6cd876c0$var$unsetRect(multiDragElement);
                });
                 // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $ccad6e4b6cd876c0$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($ccad6e4b6cd876c0$var$folding && ~$ccad6e4b6cd876c0$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($ccad6e4b6cd876c0$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $ccad6e4b6cd876c0$var$folding ? $ccad6e4b6cd876c0$var$getRect(multiDragElement) : dragRect
                    });
                    $ccad6e4b6cd876c0$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $ccad6e4b6cd876c0$var$folding = false;
                $ccad6e4b6cd876c0$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $ccad6e4b6cd876c0$var$initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $ccad6e4b6cd876c0$var$multiDragElements.length > 1 && ($ccad6e4b6cd876c0$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $ccad6e4b6cd876c0$var$getRect($ccad6e4b6cd876c0$var$dragEl$1, false, true, true);
                    $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $ccad6e4b6cd876c0$var$dragEl$1) return;
                        $ccad6e4b6cd876c0$var$setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $ccad6e4b6cd876c0$var$folding = true;
                } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$ccad6e4b6cd876c0$var$folding) $ccad6e4b6cd876c0$var$removeMultiDragElements();
                    if ($ccad6e4b6cd876c0$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $ccad6e4b6cd876c0$var$clonesHidden;
                        activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$ccad6e4b6cd876c0$var$clonesHidden && clonesHiddenBefore) $ccad6e4b6cd876c0$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $ccad6e4b6cd876c0$var$clonesFromRect
                            });
                            clone.fromRect = $ccad6e4b6cd876c0$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $ccad6e4b6cd876c0$var$clonesFromRect = $ccad6e4b6cd876c0$var$_extends({}, dragRect);
                var dragMatrix = $ccad6e4b6cd876c0$var$matrix($ccad6e4b6cd876c0$var$dragEl$1, true);
                $ccad6e4b6cd876c0$var$clonesFromRect.top -= dragMatrix.f;
                $ccad6e4b6cd876c0$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($ccad6e4b6cd876c0$var$folding) {
                $ccad6e4b6cd876c0$var$folding = false;
                $ccad6e4b6cd876c0$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children; // Multi-drag selection
            if (!$ccad6e4b6cd876c0$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $ccad6e4b6cd876c0$var$toggleClass($ccad6e4b6cd876c0$var$dragEl$1, options.selectedClass, !~$ccad6e4b6cd876c0$var$multiDragElements.indexOf($ccad6e4b6cd876c0$var$dragEl$1));
                if (!~$ccad6e4b6cd876c0$var$multiDragElements.indexOf($ccad6e4b6cd876c0$var$dragEl$1)) {
                    $ccad6e4b6cd876c0$var$multiDragElements.push($ccad6e4b6cd876c0$var$dragEl$1);
                    $ccad6e4b6cd876c0$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $ccad6e4b6cd876c0$var$dragEl$1,
                        originalEvent: evt
                    }); // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $ccad6e4b6cd876c0$var$lastMultiDragSelect && sortable.el.contains($ccad6e4b6cd876c0$var$lastMultiDragSelect)) {
                        var lastIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$lastMultiDragSelect), currentIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$ccad6e4b6cd876c0$var$multiDragElements.indexOf(children[i])) continue;
                                $ccad6e4b6cd876c0$var$toggleClass(children[i], options.selectedClass, true);
                                $ccad6e4b6cd876c0$var$multiDragElements.push(children[i]);
                                $ccad6e4b6cd876c0$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $ccad6e4b6cd876c0$var$lastMultiDragSelect = $ccad6e4b6cd876c0$var$dragEl$1;
                    $ccad6e4b6cd876c0$var$multiDragSortable = toSortable;
                } else {
                    $ccad6e4b6cd876c0$var$multiDragElements.splice($ccad6e4b6cd876c0$var$multiDragElements.indexOf($ccad6e4b6cd876c0$var$dragEl$1), 1);
                    $ccad6e4b6cd876c0$var$lastMultiDragSelect = null;
                    $ccad6e4b6cd876c0$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $ccad6e4b6cd876c0$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            } // Multi-drag drop
            if ($ccad6e4b6cd876c0$var$dragStarted && this.isMultiDrag) {
                $ccad6e4b6cd876c0$var$folding = false; // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$ccad6e4b6cd876c0$var$expando].options.sort || parentEl !== rootEl) && $ccad6e4b6cd876c0$var$multiDragElements.length > 1) {
                    var dragRect = $ccad6e4b6cd876c0$var$getRect($ccad6e4b6cd876c0$var$dragEl$1), multiDragIndex = $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$ccad6e4b6cd876c0$var$initialFolding && options.animation) $ccad6e4b6cd876c0$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$ccad6e4b6cd876c0$var$initialFolding) {
                        if (options.animation) {
                            $ccad6e4b6cd876c0$var$dragEl$1.fromRect = dragRect;
                            $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $ccad6e4b6cd876c0$var$dragEl$1) {
                                    var rect = $ccad6e4b6cd876c0$var$folding ? $ccad6e4b6cd876c0$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect; // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $ccad6e4b6cd876c0$var$removeMultiDragElements();
                        $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        }); // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $ccad6e4b6cd876c0$var$index($ccad6e4b6cd876c0$var$dragEl$1)) {
                            var update = false;
                            $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $ccad6e4b6cd876c0$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) dispatchSortableEvent("update");
                        }
                    } // Must be done after capturing individual rects (scroll bar)
                    $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                        $ccad6e4b6cd876c0$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $ccad6e4b6cd876c0$var$multiDragSortable = toSortable;
            } // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $ccad6e4b6cd876c0$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $ccad6e4b6cd876c0$var$dragStarted = false;
            $ccad6e4b6cd876c0$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $ccad6e4b6cd876c0$var$off(document, "pointerup", this._deselectMultiDrag);
            $ccad6e4b6cd876c0$var$off(document, "mouseup", this._deselectMultiDrag);
            $ccad6e4b6cd876c0$var$off(document, "touchend", this._deselectMultiDrag);
            $ccad6e4b6cd876c0$var$off(document, "keydown", this._checkKeyDown);
            $ccad6e4b6cd876c0$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $ccad6e4b6cd876c0$var$dragStarted !== "undefined" && $ccad6e4b6cd876c0$var$dragStarted) return; // Only deselect if selection is in this sortable
            if ($ccad6e4b6cd876c0$var$multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable
            if (evt && $ccad6e4b6cd876c0$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($ccad6e4b6cd876c0$var$multiDragElements.length){
                var el = $ccad6e4b6cd876c0$var$multiDragElements[0];
                $ccad6e4b6cd876c0$var$toggleClass(el, this.options.selectedClass, false);
                $ccad6e4b6cd876c0$var$multiDragElements.shift();
                $ccad6e4b6cd876c0$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $ccad6e4b6cd876c0$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$ccad6e4b6cd876c0$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$ccad6e4b6cd876c0$var$multiDragElements.indexOf(el)) return;
                if ($ccad6e4b6cd876c0$var$multiDragSortable && $ccad6e4b6cd876c0$var$multiDragSortable !== sortable) {
                    $ccad6e4b6cd876c0$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $ccad6e4b6cd876c0$var$multiDragSortable = sortable;
                }
                $ccad6e4b6cd876c0$var$toggleClass(el, sortable.options.selectedClass, true);
                $ccad6e4b6cd876c0$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$ccad6e4b6cd876c0$var$expando], _$index = $ccad6e4b6cd876c0$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~_$index) return;
                $ccad6e4b6cd876c0$var$toggleClass(el, sortable.options.selectedClass, false);
                $ccad6e4b6cd876c0$var$multiDragElements.splice(_$index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                }); // multiDragElements will already be sorted if folding
                var newIndex;
                if ($ccad6e4b6cd876c0$var$folding && multiDragElement !== $ccad6e4b6cd876c0$var$dragEl$1) newIndex = -1;
                else if ($ccad6e4b6cd876c0$var$folding) newIndex = $ccad6e4b6cd876c0$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $ccad6e4b6cd876c0$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $ccad6e4b6cd876c0$var$_toConsumableArray($ccad6e4b6cd876c0$var$multiDragElements),
                clones: [].concat($ccad6e4b6cd876c0$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $ccad6e4b6cd876c0$var$insertMultiDragElements(clonesInserted, rootEl) {
    $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $ccad6e4b6cd876c0$var$insertMultiDragClones(elementsInserted, rootEl) {
    $ccad6e4b6cd876c0$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $ccad6e4b6cd876c0$var$removeMultiDragElements() {
    $ccad6e4b6cd876c0$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $ccad6e4b6cd876c0$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$ccad6e4b6cd876c0$export$31b3ca70d8f57423.mount(new $ccad6e4b6cd876c0$var$AutoScrollPlugin());
$ccad6e4b6cd876c0$export$31b3ca70d8f57423.mount($ccad6e4b6cd876c0$var$Remove, $ccad6e4b6cd876c0$var$Revert);
var $ccad6e4b6cd876c0$export$2e2bcd8739ae039 = $ccad6e4b6cd876c0$export$31b3ca70d8f57423;



var $Loi7S = parcelRequire("Loi7S");

var $2B8he = parcelRequire("2B8he");

var $gpGF7 = parcelRequire("gpGF7");

var $ev0Km = parcelRequire("ev0Km");

var $4HRPq = parcelRequire("4HRPq");
var $a1316a21d0890d60$var$ScrumBoard = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $dACZV._)(ScrumBoard, appView);
    var _super = (0, $jhb1H._)(ScrumBoard);
    function ScrumBoard() {
        (0, $5kWiG._)(this, ScrumBoard);
        var _this;
        _this = _super.call(this);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_containterItem", ".card");
        _this.initialize();
        _this.cardId = null;
        _this.cardSection = null;
        _this.cardOrder = null;
        return _this;
    }
    (0, $hHaEF._)(ScrumBoard, [
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._setupEventListeners()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_setupEventListeners",
            value: function _setupEventListeners() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this._renderTaskContainers()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._renderTaskCards()
                                ];
                            case 2:
                                _state.sent();
                                _this._hideClearAllBtn();
                                _this._taskSortable();
                                _this._addNewListModal();
                                _this._addNewList();
                                _this._renderFunctions();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_taskSortable",
            value: function _taskSortable() {
                var _this = this;
                var sortableElements = document.querySelectorAll(".connect-sorting-content");
                if (sortableElements) sortableElements.forEach(function(element) {
                    new (0, $ccad6e4b6cd876c0$export$2e2bcd8739ae039)(element, {
                        group: "connect-sorting-content",
                        ghostClass: "sortable-placeholder",
                        animation: 150,
                        forcePlaceholderSize: true,
                        onEnd: (function(event) {
                            var _this = this;
                            var parentContainer = event.from.closest(".task-list-container");
                            var finalContainer = event.to.closest(".task-list-container");
                            var parentSection = parentContainer.getAttribute("data-section");
                            var finalSection = finalContainer.getAttribute("data-section");
                            this._updateCards(finalContainer, finalSection).then(function(validSections) {
                                _this._updateTaskAttribute(validSections, finalSection);
                                return _this._updateCards(parentContainer, parentSection);
                            }).then(function(validParentSections) {
                                _this._updateTaskAttribute(validParentSections, parentSection);
                                _this._hideClearAllBtn();
                            })["catch"](function(err) {
                                console.error(err);
                            });
                        }).bind(_this)
                    });
                });
            }
        },
        {
            key: "_updateCards",
            value: function _updateCards(container, section) {
                var _this = this;
                var cardTasks = container.querySelectorAll(".card");
                var updatePromises = [];
                cardTasks.forEach(function(card, index) {
                    var cardId = card.getAttribute("data-card-id");
                    var options = {
                        tasksection: section,
                        order: index
                    };
                    var updatePromise = $gpGF7.updateItemInDatabase(cardId, "scrumboard", options).then(function() {
                        return {
                            cardId: cardId,
                            order: options.order
                        };
                    })["catch"](function(err) {
                        _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                        return null;
                    });
                    updatePromises.push(updatePromise);
                });
                return Promise.all(updatePromises);
            }
        },
        {
            key: "_containerSortable",
            value: function _containerSortable() {
                var sortableElement = document.querySelector(".task-list-section");
                if (sortableElement) new (0, $ccad6e4b6cd876c0$export$2e2bcd8739ae039)(sortableElement, {
                    connectWith: ".task-list-container",
                    draggable: ".task-list-container",
                    ghostClass: "sortable-placeholder",
                    chosenClass: "sortable-chosen",
                    animation: 150,
                    forcePlaceholderSize: true,
                    onUpdate: (function(event) {
                        var _this = this;
                        var containerElements = document.querySelectorAll(".task-list-container");
                        var updatePromises = [];
                        containerElements.forEach(function(container, index) {
                            var containerId = container.getAttribute("data-section");
                            var newPosition = {
                                order: index
                            };
                            console.log(containerId, newPosition);
                            var updatePromise = $gpGF7.updateItemInDatabase(containerId, "scrumlist", newPosition).then(function() {
                                return {
                                    containerId: containerId,
                                    order: newPosition.order
                                };
                            })["catch"](function(err) {
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return null;
                            });
                            updatePromises.push(updatePromise);
                        });
                        Promise.all(updatePromises).then(function(sections) {
                            var validSections = sections.filter(function(section) {
                                return section !== null;
                            });
                            _this._updateContainerAttribute(validSections);
                        })["catch"](function(err) {
                            console.error(err);
                        });
                    }).bind(this)
                });
            }
        },
        {
            key: "_updateContainerAttribute",
            value: function _updateContainerAttribute(sections) {
                sections.forEach(function(param) {
                    var containerId = param.containerId, order = param.order;
                    var container = document.querySelector('[data-section="'.concat(containerId, '"]'));
                    container.dataset.order = order;
                });
            }
        },
        {
            key: "_updateTaskAttribute",
            value: function _updateTaskAttribute(sections, parentSection) {
                sections.forEach(function(param) {
                    var cardId = param.cardId, order = param.order;
                    // console.log(cardId, order, parentSection);
                    var cardList = document.querySelector('[data-card-id="'.concat(cardId, '"]'));
                    cardList.dataset.order = order;
                    cardList.dataset.listId = parentSection;
                });
            }
        },
        {
            key: "_renderTaskContainers",
            value: function _renderTaskContainers() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var listParent, storedOrder, sortedItems, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, markup, err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                listParent = document.querySelector(".task-list-section");
                                if (!listParent) return [
                                    2
                                ];
                                return [
                                    4,
                                    $gpGF7.getAllItemsFromDatabase("scrumlist")
                                ];
                            case 1:
                                storedOrder = _state.sent();
                                sortedItems = _this._sortDataByOrder(storedOrder);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = sortedItems[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        item = _step.value;
                                        markup = (0, $ev0Km.default).scrumListMarkup(item);
                                        listParent.insertAdjacentHTML("beforeend", markup);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_renderTaskCards",
            value: function _renderTaskCards() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var containers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err, err1;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    9,
                                    ,
                                    10
                                ]);
                                containers = document.querySelectorAll(".task-list-container");
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _loop = function() {
                                    var data, listAtrr, filterFunction, storedData, sortedOrder;
                                    return (0, $gAasq.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                data = _step.value;
                                                listAtrr = data.getAttribute("data-section");
                                                filterFunction = function(item) {
                                                    return item.tasksection === listAtrr;
                                                };
                                                return [
                                                    4,
                                                    $gpGF7.getAllItemsFromDatabase("scrumboard", filterFunction)
                                                ];
                                            case 1:
                                                storedData = _state.sent();
                                                sortedOrder = _this._sortDataByOrder(storedData);
                                                // console.log(sortedOrder);
                                                return [
                                                    4,
                                                    _this.displayScrum(sortedOrder, listAtrr, true)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = containers[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                return [
                                    5,
                                    (0, $gAasq.__values)(_loop())
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                err1 = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_sortDataByOrder",
            value: function _sortDataByOrder(data) {
                return data.sort(function(a, b) {
                    return a.order - b.order;
                });
            }
        },
        {
            key: "_addNewListModal",
            value: function _addNewListModal() {
                var listBtn = document.getElementById("add-list");
                if (listBtn) $(listBtn).off("click").on("click", function(event) {
                    event.preventDefault();
                    document.querySelector(".add-list").style.display = "block";
                    document.querySelector(".edit-list").style.display = "none";
                    document.querySelector(".edit-list-title").style.display = "none";
                    document.querySelector(".add-list-title").style.display = "block";
                    $("#addListModal").modal("show");
                });
            }
        },
        {
            key: "_addNewList",
            value: function _addNewList() {
                var listBtn = document.querySelector(".add-list");
                if (listBtn) {
                    var self = this;
                    $(listBtn).off("click").on("click", function() {
                        var _ref = (0, $e2996._)(function(event) {
                            var listIndex, data, storeData, markup, err;
                            return (0, $gAasq.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            $gpGF7.getObjectStoreLength("scrumlist")
                                        ];
                                    case 1:
                                        listIndex = _state.sent();
                                        data = $Loi7S.createNewList(false, null, listIndex);
                                        return [
                                            4,
                                            $gpGF7.addItemtoDatabase(data, "scrumlist")
                                        ];
                                    case 2:
                                        storeData = _state.sent();
                                        markup = (0, $ev0Km.default).scrumListMarkup(storeData);
                                        document.querySelector(".task-list-section").insertAdjacentHTML("beforeend", markup);
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        err = _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        $("#addListModal").modal("hide");
                                        document.getElementById("s-list-name").value = "";
                                        self._renderFunctions();
                                        return [
                                            7
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(event) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
            }
        },
        {
            key: "_renderFunctions",
            value: function _renderFunctions() {
                this._taskSortable();
                this._editList();
                this._deleteList();
                this._clearCardList();
                this._taskEdit();
                this._addTaskClick();
                this._taskDelete();
                this._containerSortable();
                this._onEditTaskClick();
            }
        },
        {
            key: "_taskDelete",
            value: function _taskDelete() {
                var deleteBtn = document.querySelectorAll(".card .s-task-delete");
                if (deleteBtn) {
                    var self = this;
                    $(deleteBtn).off("click").on("click", function(event) {
                        event.preventDefault();
                        var cardParent = event.target.closest(".card");
                        $("#deleteConformation").modal("show");
                        document.querySelectorAll('[data-remove="task"]').forEach(function(btn) {
                            btn.addEventListener("click", function() {
                                var _ref = (0, $e2996._)(function(event) {
                                    var cardId, err;
                                    return (0, $gAasq.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                event.preventDefault();
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    4,
                                                    5
                                                ]);
                                                cardId = cardParent.getAttribute("data-card-id");
                                                return [
                                                    4,
                                                    $gpGF7.deleteItemFromDatabase(cardId, "scrumboard")
                                                ];
                                            case 2:
                                                _state.sent();
                                                cardParent.remove();
                                                self.successMessageInfo((0, $4HRPq.ITEMSDELETED));
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 3:
                                                err = _state.sent();
                                                self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 4:
                                                $("#deleteConformation").modal("hide");
                                                self._hideClearAllBtn();
                                                return [
                                                    7
                                                ];
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(event) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        });
                    });
                }
            }
        },
        {
            key: "_taskEdit",
            value: function _taskEdit() {
                var editBtn = document.querySelectorAll(".card .s-task-edit");
                if (editBtn) {
                    var self = this;
                    $(editBtn).off("click").on("click", function(event) {
                        event.preventDefault();
                        var outerThis = this;
                        var taskTitleElement = outerThis.closest(".card").querySelector("h4");
                        var taskTextElement = outerThis.closest(".card").querySelector('p:not([class="progress-count"])');
                        var progressElement = outerThis.closest(".card").querySelector("div.progress-bar");
                        document.querySelector(".add-task-title").style.display = "none";
                        document.querySelector(".edit-task-title").style.display = "block";
                        document.querySelector('[data-btnfn="addTask"]').style.display = "none";
                        document.querySelector('[data-btnfn="editTask"]').style.display = "block";
                        var _taskTitleElement_getAttribute;
                        var taskTitle = (_taskTitleElement_getAttribute = taskTitleElement === null || taskTitleElement === void 0 ? void 0 : taskTitleElement.getAttribute("data-taskTitle")) !== null && _taskTitleElement_getAttribute !== void 0 ? _taskTitleElement_getAttribute : "";
                        var _taskTextElement_getAttribute;
                        var taskText = (_taskTextElement_getAttribute = taskTextElement === null || taskTextElement === void 0 ? void 0 : taskTextElement.getAttribute("data-taskText")) !== null && _taskTextElement_getAttribute !== void 0 ? _taskTextElement_getAttribute : "";
                        var _progressElement_getAttribute;
                        var taskProgress = (_progressElement_getAttribute = progressElement === null || progressElement === void 0 ? void 0 : progressElement.getAttribute("data-progressState")) !== null && _progressElement_getAttribute !== void 0 ? _progressElement_getAttribute : "";
                        document.getElementById("s-task").value = taskTitle;
                        document.getElementById("s-text").value = taskText;
                        document.getElementById("s-progress").value = +taskProgress || "";
                        self.cardId = outerThis.closest(".card").getAttribute("data-card-id");
                        self.cardSection = outerThis.closest(".card").getAttribute("data-list-id");
                        self.cardOrder = outerThis.closest(".card").getAttribute("data-order");
                        $("#addTaskModal").modal("show");
                        self._hideModalInfo();
                    });
                }
            }
        },
        {
            key: "_onEditTaskClick",
            value: function _onEditTaskClick() {
                var editBtn = document.querySelector('[data-btnfn="editTask"]');
                if (editBtn) {
                    var self = this;
                    $(editBtn).off("click").on("click", function() {
                        var _ref = (0, $e2996._)(function(event) {
                            var containerElement, options, data, markup, err;
                            return (0, $gAasq.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        event.preventDefault();
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        containerElement = document.querySelector('.connect-sorting-content .card[data-card-id="'.concat(self.cardId, '"]'));
                                        options = {
                                            id: self.cardId,
                                            tasksection: self.cardSection,
                                            order: self.cardOrder
                                        };
                                        data = $Loi7S.createScrumBoard(options, true);
                                        return [
                                            4,
                                            $gpGF7.updateItemInDatabase(self.cardId, "scrumboard", data)
                                        ];
                                    case 2:
                                        _state.sent();
                                        markup = (0, $ev0Km.default).scrumBoardMarkup(data);
                                        self.update(data, markup, containerElement);
                                        self.successMessageInfo((0, $4HRPq.SUCCESSUPDATE));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        err = _state.sent();
                                        self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        self.cardId = null;
                                        self.cardSection = null;
                                        self.cardOrder = null;
                                        $("#addTaskModal").modal("hide");
                                        self._hideModalInfo();
                                        self._renderFunctions();
                                        return [
                                            7
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(event) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
            }
        },
        {
            key: "_deleteList",
            value: function _deleteList() {
                var deleteBtn = document.querySelectorAll(".list-delete");
                if (deleteBtn) {
                    var self = this;
                    $(deleteBtn).off("click").on("click", function(event) {
                        event.preventDefault();
                        var listContainer = event.target.closest('[data-connect="sorting"]');
                        $("#deleteConformation").find(".modal-body p").text((0, $4HRPq.LISTDELETECONFIRM));
                        $("#deleteConformation").modal("show");
                        document.querySelector('[data-remove="task"]').addEventListener("click", /*#__PURE__*/ (0, $e2996._)(function() {
                            var listId, cardTasks, trashCards, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, card, cardId, err1;
                            return (0, $gAasq.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            3,
                                            4,
                                            5
                                        ]);
                                        listId = listContainer.getAttribute("data-section");
                                        cardTasks = listContainer.querySelectorAll(".connect-sorting-content .card");
                                        trashCards = [];
                                        return [
                                            4,
                                            $gpGF7.deleteItemFromDatabase(listId, "scrumlist")
                                        ];
                                    case 1:
                                        _state.sent();
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = cardTasks[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                card = _step.value;
                                                cardId = card.getAttribute("data-card-id");
                                                trashCards.push(cardId);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return [
                                            4,
                                            $gpGF7.deleteMultipleItemsFromDatabase(trashCards, "scrumboard")
                                        ];
                                    case 2:
                                        _state.sent();
                                        listContainer.remove();
                                        self.successMessageInfo((0, $4HRPq.SUCCESSUPDATE));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        err1 = _state.sent();
                                        self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        $("#deleteConformation").modal("hide");
                                        return [
                                            7
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    });
                }
            }
        },
        {
            key: "_hideClearAllBtn",
            value: function _hideClearAllBtn() {
                var containerElement = document.querySelectorAll(".task-list-container");
                containerElement.forEach(function(container) {
                    var cardArr = container.querySelector(".list-clear-all");
                    var containerCard = container.querySelectorAll(".connect-sorting-content .card");
                    if (containerCard.length === 0 || containerCard.length === 1) cardArr.style.display = "none";
                    else if (containerCard.length > 1) cardArr.style.display = "block";
                });
            }
        },
        {
            key: "_clearCardList",
            value: function _clearCardList() {
                var clearBtn = document.querySelectorAll(".list-clear-all");
                if (clearBtn) {
                    var self = this;
                    $(clearBtn).off("click").on("click", function(event) {
                        event.preventDefault();
                        var listContainer = event.target.closest('[data-connect="sorting"]').querySelectorAll(".connect-sorting-content .card");
                        $("#deleteConformation").modal("show");
                        document.querySelector('[data-remove="task"]').addEventListener("click", /*#__PURE__*/ (0, $e2996._)(function() {
                            var trashCards, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, card, cardId, err1;
                            return (0, $gAasq.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            3,
                                            4
                                        ]);
                                        trashCards = [];
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = listContainer[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                card = _step.value;
                                                cardId = card.getAttribute("data-card-id");
                                                trashCards.push(cardId);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return [
                                            4,
                                            $gpGF7.deleteMultipleItemsFromDatabase(trashCards, "scrumboard")
                                        ];
                                    case 1:
                                        _state.sent();
                                        listContainer.forEach(function(list) {
                                            return list.remove();
                                        });
                                        self.successMessageInfo((0, $4HRPq.SUCCESSUPDATE));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 2:
                                        err1 = _state.sent();
                                        self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        $("#deleteConformation").modal("hide");
                                        return [
                                            7
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    });
                }
            }
        },
        {
            key: "_editList",
            value: function _editList() {
                var editBtn = document.querySelectorAll(".list-edit");
                if (editBtn) {
                    var handleListEdit = function handleListEdit(event) {
                        event.preventDefault();
                        var outerThis = event.target;
                        var listContainer = outerThis.closest('[data-connect="sorting"]');
                        var listTitleElement = listContainer.querySelector(".s-heading");
                        document.querySelector(".add-list").style.display = "none";
                        document.querySelector(".edit-list").style.display = "block";
                        document.querySelector(".add-list-title").style.display = "none";
                        document.querySelector(".edit-list-title").style.display = "block";
                        var listTitle = listTitleElement.getAttribute("data-listTitle");
                        document.getElementById("s-list-name").value = listTitle;
                        document.querySelector(".edit-list").removeEventListener("click", handleInnerListEdit);
                        document.querySelector(".edit-list").addEventListener("click", handleInnerListEdit);
                        function handleInnerListEdit(event) {
                            return _handleInnerListEdit.apply(this, arguments);
                        }
                        function _handleInnerListEdit() {
                            _handleInnerListEdit = (0, $e2996._)(function(event) {
                                var innerThis, editedListTitle, dataSection, dataOrder, options, data, err;
                                return (0, $gAasq.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                3,
                                                4
                                            ]);
                                            innerThis = event.target;
                                            editedListTitle = document.getElementById("s-list-name").value;
                                            dataSection = listTitleElement.closest(".task-list-container").getAttribute("data-section");
                                            dataOrder = listTitleElement.closest(".task-list-container").getAttribute("data-order");
                                            options = {
                                                section: dataSection,
                                                order: dataOrder
                                            };
                                            data = $Loi7S.createNewList(true, options);
                                            return [
                                                4,
                                                $gpGF7.updateItemInDatabase(dataSection, "scrumlist", data)
                                            ];
                                        case 1:
                                            _state.sent();
                                            listTitleElement.innerHTML = editedListTitle;
                                            listTitleElement.setAttribute("data-listTitle", editedListTitle);
                                            self.successMessageInfo((0, $4HRPq.SUCCESSUPDATE));
                                            return [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            err = _state.sent();
                                            self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            $("#addListModal").modal("hide");
                                            $("#s-list-name").val("");
                                            return [
                                                7
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return _handleInnerListEdit.apply(this, arguments);
                        }
                        $("#addListModal").modal("show");
                        $("#addListModal").on("hidden.bs.modal", function(e) {
                            $("#s-list-name").val("");
                        });
                    };
                    var self = this;
                    editBtn.forEach(function(element) {
                        element.removeEventListener("click", handleListEdit);
                        element.addEventListener("click", handleListEdit);
                    });
                }
            }
        },
        {
            key: "_hideModalInfo",
            value: function _hideModalInfo() {
                var addTaskModal = document.getElementById("addTaskModal");
                var addListModal = document.getElementById("addListModal");
                if (addTaskModal || addListModal) $(addTaskModal, addListModal).on("hidden.bs.modal", function(event) {
                    $("input,textarea").val("");
                });
            }
        },
        {
            key: "_addTaskClick",
            value: function _addTaskClick() {
                var addTaskButtons = document.querySelectorAll(".addTask");
                if (addTaskButtons) {
                    var self = this;
                    addTaskButtons.forEach(function(button) {
                        button.addEventListener("click", function(event) {
                            event.preventDefault();
                            var parentElement = this.closest('[data-connect="sorting"]');
                            var getParentElement = parentElement.getAttribute("data-section");
                            document.querySelector(".edit-task-title").style.display = "none";
                            document.querySelector(".add-task-title").style.display = "block";
                            document.querySelector('[data-btnfn="addTask"]').style.display = "block";
                            document.querySelector('[data-btnfn="editTask"]').style.display = "none";
                            // $('.addTaskAccordion .collapse').collapse('hide');
                            $("#addTaskModal").modal("show");
                            self._renderNewTask(getParentElement);
                        });
                    });
                }
            }
        },
        {
            key: "_renderNewTask",
            value: function _renderNewTask(getParent) {
                var btnClass = document.querySelector('[data-btnfn="addTask"]');
                if (btnClass) {
                    var self = this;
                    $('[data-btnfn="addTask"]').off("click").on("click", function() {
                        var _ref = (0, $e2996._)(function(event) {
                            var tasklength, options, data, err;
                            return (0, $gAasq.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            $gpGF7.getObjectStoreLength("scrumboard")
                                        ];
                                    case 1:
                                        tasklength = _state.sent();
                                        options = {
                                            tasksection: getParent,
                                            order: tasklength
                                        };
                                        data = $Loi7S.createScrumBoard(options);
                                        _state.label = 2;
                                    case 2:
                                        _state.trys.push([
                                            2,
                                            5,
                                            6,
                                            7
                                        ]);
                                        return [
                                            4,
                                            $gpGF7.addItemtoDatabase(data, "scrumboard")
                                        ];
                                    case 3:
                                        _state.sent();
                                        return [
                                            4,
                                            self.displayScrum(data, getParent)
                                        ];
                                    case 4:
                                        _state.sent();
                                        self.successMessageInfo((0, $4HRPq.TODOSUCESS));
                                        return [
                                            3,
                                            7
                                        ];
                                    case 5:
                                        err = _state.sent();
                                        self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        $("#addTaskModal").modal("hide");
                                        self._taskDelete();
                                        self._taskEdit();
                                        self._hideModalInfo();
                                        self._hideClearAllBtn();
                                        return [
                                            7
                                        ];
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(event) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
            }
        },
        {
            key: "displayScrum",
            value: function displayScrum(data, getParent) {
                var newRender = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var _this = this;
                return (0, $e2996._)(function() {
                    return (0, $gAasq.__generator)(this, function(_state) {
                        if (newRender) data.forEach(function(item) {
                            _this._displayCards(item, getParent);
                        });
                        else _this._displayCards(data, getParent);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_displayCards",
            value: function _displayCards(data, getParent) {
                var markup = (0, $ev0Km.default).scrumBoardMarkup(data);
                var parent = document.querySelector('[data-section="'.concat(getParent, '"] .connect-sorting-content'));
                parent.insertAdjacentHTML("beforeend", markup);
            }
        }
    ]);
    return ScrumBoard;
}((0, $2B8he.default));
new $a1316a21d0890d60$var$ScrumBoard();


//# sourceMappingURL=scrumboard.97fde517.js.map
